/* Release Theme - v1.1.0 */

/* Define Breakpoints -- START */
const mobileWidth = 750;
const tabletWidth = 990;
const windowDynamicEvents = ["scroll", "resize"];

// define desktop, tablet, mobile
const isDesktop = window.innerWidth > tabletWidth;
const isTablet = window.innerWidth <= tabletWidth && window.innerWidth >= mobileWidth;
const isMobile = window.innerWidth < mobileWidth;
/* Define Breakpoints -- END */

const body = document.querySelector("body");
const main = document.querySelector("main");

/* constants */
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
  productAdded: "product-added"
};


/* SECTIONS: HEADER GROUP */
const sectionsOfHeaderGroup = Array.from(
  document.querySelectorAll(".shopify-section-group-header-group")
).filter(section => !section.classList.contains("section-header"));
// then add #header element to the end of the array
const headerElement = document.querySelector("#header, #shopify-section-main-password-header");
if (headerElement) {
  sectionsOfHeaderGroup.push(headerElement);
}

let header = document.querySelector(
  "#header, #shopify-section-main-password-header"
);
let announcementBar = document.querySelector(".js-announcement-bar");

let heroBanner = document.querySelector(".hero-banner");

/* SECTION: Header */
const isHeaderSticky = header?.classList.contains('is-sticky');

/* SECTION: Announcement Bars */
const sectionsOfAnnouncementBar = document.querySelectorAll('.section-announcement-bar');
if (sectionsOfAnnouncementBar) {
  const headerIndex = Array.prototype.indexOf.call(document.body.children, document.querySelector('header'));
  const mainIndex = Array.prototype.indexOf.call(main.parentNode.children, main);

  const setCustomProperty = (property, value) => {
    document.documentElement.style.setProperty(property, value);
  };

  function calcSectionHeights (section) {
    const sectionHeights = {
      visibleHeight : Math.max(0, Math.min(section.offsetHeight, window.innerHeight - section.getBoundingClientRect().top, section.getBoundingClientRect().bottom)),
      height : section.getBoundingClientRect().height
    };
    return sectionHeights;
  }

  function updateVisibleHeightsOfAnnouncementBars() {
    let totalVisibleHeights = 0;
    let totalHeights = 0;

    sectionsOfAnnouncementBar.forEach((section) => {
      const sectionIndex = Array.prototype.indexOf.call(section.parentNode.children, section);

      if (sectionIndex < headerIndex) {
        // calculate total heights and visible heights of all announcement bars before the header
        Array.from(sectionsOfAnnouncementBar)
          .filter((section) => {
            const index = Array.prototype.indexOf.call(section.parentNode.children, section);
            return index < headerIndex;
          })
          .forEach((section) => {
            // console.log(sectionIndex, section);
            const { height, visibleHeight } = calcSectionHeights(section);
            totalHeights += height;
            totalVisibleHeights += visibleHeight;
        });
      }
    });
    setCustomProperty(`--announcement-bars-before-header-heights`, `${parseFloat(totalHeights)}px`);
    setCustomProperty(`--announcement-bars-before-header-visible-heights`, `${parseFloat(totalVisibleHeights)}px`);
  }
  // set initial visible heights
  updateVisibleHeightsOfAnnouncementBars();
  // update visible heights on scroll and window resize
  window.addEventListener('scroll', updateVisibleHeightsOfAnnouncementBars);
  window.addEventListener('resize', updateVisibleHeightsOfAnnouncementBars);
}

/* PAGE: Collection */
/*
const pageCollection = document.querySelector('body.template--collection');
if (pageCollection) {
  const productGrid = pageCollection.querySelector('.collection-grid-container__products');
  const products = productGrid?.querySelectorAll('.product-card');

  // get .product-card__content height and set max of them as .product-card__content height
  if (products) {
    let maxProductCardContentHeight = 0;
    products.forEach(product => {
      const productCardContent = product.querySelector('.product-card__content');
      if (productCardContent) {
        productCardContent.style.height = 'auto';
        maxProductCardContentHeight = Math.max(maxProductCardContentHeight, productCardContent.offsetHeight);
      }
    });
    products.forEach(product => {
      const productCardContent = product.querySelector('.product-card__content');
      if (productCardContent) {
        productCardContent.style.height = `${maxProductCardContentHeight}px`;
      }
    });
  }
}
  */

let productMedia = document.querySelector(".main-product__media"); // on pdp
let productMediaSwiper = document.querySelector(
  ".main-product__media .swiper--product-gallery"
); // on pdp

let productCardMedia = document.querySelector(".product-card__media");
let productCardCollections = document.querySelector(".product-card");

document.addEventListener("DOMContentLoaded", function () {
  const lazyImages = document.querySelectorAll('img[loading="lazy"]:not(.animation-none)');

  lazyImages.forEach(img => {
    // add initial lazy class
    img.classList.add("lazy");
    img.addEventListener("load", function () {
      handleLazyLoadedImage(img);
    });
    if (img.complete) {
      handleLazyLoadedImage(img);
    }
  });

  function handleLazyLoadedImage(img) {
    if (!img || !img.hasAttribute("loading")) { return; }
    setTimeout(() => {
      // img.removeAttribute("loading");
      // remove lazy class after transition
      img.classList.remove("lazy");
    }, 100);
  }

  // Set observer to catch dynamicly added images with lazy loading
  function mutationCallbackForLazyLoadedImage(mutationList, observer) {
    for (const mutation of mutationList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node instanceof HTMLElement) {
            if (node.querySelector('img[loading="lazy"]')) {
              node.querySelectorAll('img[loading="lazy"]').forEach(img => {
                handleLazyLoadedImage(img);
              })
            }
          }
        })
      }
    }
  };

  const observer = new MutationObserver(mutationCallbackForLazyLoadedImage);
  observer.observe(
    document.querySelector("body"),
    { childList: true, subtree: true }
  );
  // observer.disconnect();

});

// add loading lazy attribute to div.hero__inner > div.media > video > img
document
  .querySelectorAll(".hero__inner > .media > video > img")
  .forEach(function (el) {
    el.setAttribute("loading", "lazy");
    el.setAttribute("alt", "Video Cover");
  });

// catch all images with class 'lazyload' and add loading lazy attribute
document.querySelectorAll(".lazyload").forEach(function (el) {
  el.setAttribute("loading", "lazy");
});

windowDynamicEvents.forEach(eventType => {
  window.addEventListener(eventType, () => {
    setRootCustomProperties();
  });
});

setRootCustomProperties();

if (Shopify.designMode) {
  window.addEventListener("shopify:section:load", setRootCustomProperties);
  window.addEventListener("shopify:section:select", setRootCustomProperties);
}

window.addEventListener("shopify:section:load", function () {

  header = document.querySelector(
    "#header, #shopify-section-main-password-header header"
  );
  announcementBar = document.querySelector(".js-announcement-bar");
  productCardMedia = document.querySelector(".product-card__media");
});

function getCoordinates(element) {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top + window.scrollY,
    right: rect.right + window.scrollX,
    bottom: rect.bottom + window.scrollY,
    left: rect.left + window.scrollX
  };
}

function setCustomProperty(property, value) {
  document.documentElement.style.setProperty(property, value);
}

function setRootCustomProperties() {

  const setCustomProperty = (property, value) => {
    document.documentElement.style.setProperty(property, value);
  };

  // sections of header group - height
  if (sectionsOfHeaderGroup.length > 0) {
    // console.log(sectionsOfHeaderGroup);

    const totalHeight = Array.from(sectionsOfHeaderGroup).reduce((sum, section) => {
      return sum + section.offsetHeight;
    }, 0);
    document.documentElement.style.setProperty('--header-group-height', `${totalHeight - 1}px`);
  }

  // header height
  let headerHeight = 0;
  if (header) {
    headerHeight = header.getBoundingClientRect().height.toFixed(2);
  }
  setCustomProperty("--header-height", `${parseFloat(headerHeight)}px`);

  let cartDrawerBody = document.querySelector(".cart-drawer__body");
  if (cartDrawerBody) {
    setCustomProperty("--cart-drawer-body-width", `${parseFloat(cartDrawerBody.offsetWidth)}px`);
    setCustomProperty("--cart-drawer-body-height", `${parseFloat(cartDrawerBody.offsetHeight)}px`);
  }

  // product media width
  if (productMedia) {
    setCustomProperty("--product-media-area-width", `${parseFloat(productMedia.offsetWidth)}px`);
  }

  // set initial product media area height - start
  function setInitalProductMediaAreaHeight() {
    if (productMedia && body.classList.contains("template--product")) {
      let initialProductMediaAreaHeight = 0;
      const mainTop = getCoordinates(main).top;
      const productMediaTop = getCoordinates(productMedia).top;
      const productTopbar = document.querySelector('.product__topbar-nav');
      let productTopbarHeight = 0;
      if (productTopbar) productTopbarHeight = productTopbar.offsetHeight;
      initialProductMediaAreaHeight = window.innerHeight - Math.round(mainTop) - 2 * Math.round(productMediaTop - mainTop) + Math.round(productTopbarHeight);

      // check if any section exists before product section
      const productSectionIndex = Array.prototype.indexOf.call(main.children, document.querySelector('main section.main-product'));
      if (productSectionIndex > 0) {
        initialProductMediaAreaHeight = window.innerHeight - Math.round(mainTop) - 2 * Math.round(productMediaTop - mainTop) + Math.round(productTopbarHeight);
      }

      initialProductMediaAreaHeight = Math.round(initialProductMediaAreaHeight - 24);

      // set initial product media area height
      setCustomProperty("--product-media-area-height", initialProductMediaAreaHeight + "px");
    }
  }
  function setInitalProductMediaSwiperAreaHeight() {
    const sliderWrapper = document.querySelector('.main-product__media--slider-wrapper');
    if (!sliderWrapper) return;
    setCustomProperty(
      "--product-media-area-swiper-height",
      `${parseInt(sliderWrapper.offsetHeight)}px`
    );
  }
  document.addEventListener("DOMContentLoaded", setInitalProductMediaAreaHeight);
  window.addEventListener("resize", setInitalProductMediaAreaHeight);
  window.addEventListener("change", setInitalProductMediaAreaHeight);

  document.addEventListener("DOMContentLoaded", setInitalProductMediaSwiperAreaHeight);
  window.addEventListener("resize", setInitalProductMediaSwiperAreaHeight);
  window.addEventListener("change", setInitalProductMediaSwiperAreaHeight);
  if (Shopify.designMode) {
    // window.addEventListener('shopify:section:load', setInitalProductMediaAreaHeight);
    window.addEventListener('shopify:section:load', setInitalProductMediaSwiperAreaHeight);
  }
  // set initial product media area height - end

  if (heroBanner) {
    setCustomProperty("--hero-banner-top", `${parseFloat(getCoordinates(heroBanner).top)}px`);
    setCustomProperty("--hero-banner-bottom", `${parseFloat(getCoordinates(heroBanner).bottom)}px`);
  }

  const articleHeroMedia = document.querySelector(".js-article-hero-media");
  const articleContent = document.querySelector(".js-article-content");
  if (articleHeroMedia || articleContent) {
    // set social share sticky position according to article hero media or article content
    let socialShareStickyTop = 0;
    let socialShareStickyStart = 0;
    let headerBottom = parseInt(header.getBoundingClientRect().bottom);
    if (articleHeroMedia) {
      socialShareStickyTop = parseInt(articleHeroMedia.getBoundingClientRect().top);
      socialShareStickyStart = parseInt(articleHeroMedia.getBoundingClientRect().right);
    } else {
      socialShareStickyTop = parseInt(articleContent.getBoundingClientRect().y);
      socialShareStickyStart = parseInt(articleContent.getBoundingClientRect().right);
    }

    if (socialShareStickyTop < (0 + headerBottom)) {
      socialShareStickyTop = headerBottom;
    }

    setCustomProperty(
      "--social-share-sticky-top",
      `${socialShareStickyTop}px`
    );
    setCustomProperty(
      "--social-share-sticky-start",
      `${socialShareStickyStart}px`
    );

  }

  // transparent header menu color
  // get data-header-menu-text-color of first .hero__inner under .hero-banner element
  if (heroBanner) {
    let heroInner = heroBanner.querySelectorAll(".hero__inner");
    if (heroInner.length > 0) {
      let heroInnerFirst = heroInner[0];
      let headerMenuTextColor = heroInnerFirst.getAttribute("data-header-menu-text-color");
      if (headerMenuTextColor) {
        setCustomProperty(
          "--transparent-header-menu-text-color", `${headerMenuTextColor}`
        );
      }
    }
  } else {
    setCustomProperty(
      "--transparent-header-menu-text-color", `var(--color-background)`
    );
  }

  if (productCardMedia) {
    setCustomProperty(
      "--product-card-media-height",
      `${parseInt(productCardMedia.offsetHeight)}px`
    );
  }
}

// scroll-position
function scrollPositionY() {
  setCustomProperty("--window-scroll-y-position", window.scrollY);
  if (window.scrollY === 0) {
    document.body.classList.add('is-at-top');
    document.body.classList.remove('is-scrolled');
  } else {
    document.body.classList.add('is-scrolled');
    document.body.classList.remove('is-at-top');
  }
}
scrollPositionY();
window.addEventListener("scroll", scrollPositionY);


const bodyScroll = {
  lock(container) {
    bodyScrollLock.disableBodyScroll(container);
  },
  unlock(container) {
    bodyScrollLock.enableBodyScroll(container);
  },
  clear() {
    bodyScrollLock.clearAllBodyScrollLocks();
  }
};

const onKeyUpEscape = event => {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus({
    preventScroll: true
  });
};

const getFocusableElements = container => {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
    )
  );
};

document
  .querySelectorAll('[id^="Details-"] summary')
  .forEach(summary => {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    );

    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute(
        "aria-controls",
        summary.nextElementSibling.id
      );
    }

    summary.addEventListener("click", event => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    if (summary.closest("header-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  });

const trapFocusHandlers = {};

const removeTrapFocus = (elementToFocus = null) => {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener(
    "focusout",
    trapFocusHandlers.focusout
  );
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus)
    elementToFocus.focus({
      preventScroll: true
    });
};

const trapFocus = (container, elementToFocus = container) => {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener(
      "keydown",
      trapFocusHandlers.keydown
    );
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
};

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

const deepClone = obj => {
  return JSON.parse(JSON.stringify(obj));
};

const handleize = str => str.replace(/[ /_]/g, "-").toLowerCase();

const decode = str => decodeURIComponent(str).replace(/\+/g, " ");

const getOffsetTop = element => {
  let offsetTop = 0;

  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }
  } while ((element = element.offsetParent));

  return offsetTop;
};

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.drawer = this.querySelector(".js-drawer");
    this.overlay = this.querySelector(".js-drawer-overlay");
    this.btnsCloseDrawer = this.querySelectorAll(
      ".js-btn-close-drawer"
    );
    this.btnsCloseDrawer = [...this.btnsCloseDrawer].filter(
      btnCloseDrawer =>
        this.drawer === btnCloseDrawer.closest(".js-drawer")
    );
    this.elementToFocus =
      this.querySelector(".js-drawer-focus-element") ||
      this.btnsCloseDrawer[0];
    this.toggleButtons = [this.summary, ...this.btnsCloseDrawer];
    this.isParentDrawerOpen = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.HeaderDrawer = document.querySelector("header-drawer");

    this.setInitialAccessibilityAttr();

    if (this.overlay) {
      this.overlay.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.details.hasAttribute("open")) {
          this.toggleDrawer(e);
        }
      });
    }

    this.toggleButtons.forEach(toggleButton => {
      toggleButton.addEventListener("click", e => {
        e.preventDefault();

        this.toggleDrawer(e);
      });
    });

    this.addEventListener("keydown", e => {
      const isEscapeKey = e.key === "Escape";
      const isDrawerOpen =
        this.details.classList.contains("menu-opening");
      const nestedOpenDrawer =
        this.details.querySelector("details[open]");

      if (!isEscapeKey || nestedOpenDrawer || !isDrawerOpen) {
        return;
      }

      if (
        this.predictiveSearch &&
        this.predictiveSearch.input == document.activeElement
      ) {
        return;
      }

      this.toggleDrawer(e);
    });

    this.toggleTrapFocus();
  }

  toggleDrawer(e = undefined) {
    const isDrawerTransitioning = this.details.classList.contains(
      "drawer-transitioning"
    );

    // const isDetailsOpen = this.details.classList.contains('menu-opening');
    const isDetailsOpen = this.details.hasAttribute("open");
    const headerDiv = document.getElementById("header");
    if (!isDetailsOpen) {

      // this.closeAllOtherDrawers();

      this.details.setAttribute("open", "");
      this.toggleButtons.forEach(toggleButton => {
        toggleButton.classList.add("menu-is-open");
        toggleButton.setAttribute("aria-expanded", true);
      });
      this.details.classList.add("menu-opening");
      headerDiv.classList.add("menu-open");
      const bodyHasOverflow = body.style.overflow === "hidden";
      if (bodyHasOverflow) {
        this.parentDrawer = this.closest(".js-drawer");
        if (this.parentDrawer) {
          this.isParentDrawerOpen = true;
          this.parentDrawer.classList.add("drawer--nested-open");
        }
      } else {
          body.style.overflow = "hidden";
          body.classList.add("drawer--is-open");
          document.documentElement.style.overflow = "hidden";
        // Commenting out the following lines to prevent document scrolling to the top
        // document.documentElement.style.position = "fixed";
        // document.documentElement.style.width = "100%";
      }
      var searchInput = this.querySelector("#search-desktop");
      if (searchInput) {
        searchInput.focus();
        if (headerDiv) {
          headerDiv.classList.remove("menu-open");
        }
      }
    } else {
      this.details.classList.remove("menu-opening");
      this.toggleButtons.forEach(toggleButton => {
        toggleButton.classList.remove("menu-is-open");
        toggleButton.setAttribute("aria-expanded", false);
      });
      if(!e?.target?.closest('.cart-item')){
          body.style.overflow = "";
        }
        document.documentElement.style.overflow = "";
        document.documentElement.style.position = "";
        document.documentElement.style.width = "";
      body.classList.remove("drawer--is-open");
      if (this.isParentDrawerOpen) {
        this.parentDrawer.classList.remove("drawer--nested-open");
      }
      /** removing this attr witout timeout causes transition issues */
      setTimeout(() => {
        this.details.removeAttribute("open");
      }, 500);
    }

    const handleDropdownTransition = e => {
      if (
        e.target !== this.drawer ||
        e.propertyName !== "visibility"
      ) {
        return;
      }

      this.details.classList.remove("drawer-transitioning");

      if (this.elementToFocus) {
        this.elementToFocus.focus({
          preventScroll: true
        });
      }

      const isDetailsOpen = this.details.hasAttribute("open");

      if (!isDetailsOpen) {
        this.toggleButtons.forEach(toggleButton => {
          toggleButton.setAttribute("aria-expanded", false);
        });
        this.summary.focus({
          preventScroll: true
        });
      }

      if (this.isParentDrawerOpen) {
        this.parentDrawer.classList.remove("drawer--nested-open");
        document.body.style.overflow = "";
      } else {
        document.body.style.overflow = "hidden";
      }

      e.target.removeEventListener(
        "transitionend",
        handleDropdownTransition
      );
    };

    this.drawer.addEventListener(
      "transitionstart",
      e => {
        this.details.classList.add("drawer-transitioning");
      },
      {
        once: true
      }
    );

    this.drawer.addEventListener(
      "transitionend",
      handleDropdownTransition
    );
  }

  /* probably not needed -- start */
  closeAllOtherDrawers() {
    const allDrawers = document.querySelectorAll(".js-drawer");
    allDrawers.forEach(drawer => {
      const details = drawer.closest("details");
      if (details && details !== this.details) {
        details.removeAttribute("open");
        drawer.style.overflow = "";
      }
    });

    document.body.style.overflow = "";
  }
  /* probably not needed -- end */

  instantlyHideDrawer() {
    this.toggleButtons.forEach(toggleButton => {
      toggleButton.setAttribute("aria-expanded", false);
    });
    this.details.classList.remove("menu-opening");
    this.details.removeAttribute("open");
    body.style.overflow = "";
  }

  toggleTrapFocus(container = this.drawer) {
    let isHandlingFocus = false;

    document.addEventListener("focusin", e => {
      if (isHandlingFocus) return;
      isHandlingFocus = true;

      const isDrawerOpen =
        this.details.classList.contains("menu-opening");

      if (!isDrawerOpen) {
        isHandlingFocus = false;
        return;
      }

      const openDrawer = e.target.closest(
        "details.menu-opening .js-drawer"
      );
      const nestedOpenDrawer = this.details.querySelector(
        "details.menu-opening"
      );

      if (openDrawer === this.drawer || nestedOpenDrawer) {
        isHandlingFocus = false;
        return;
      }

      e.preventDefault();

      const focusableElements = getFocusableElements(container);
      const focusedElementDOMPosition =
        container.compareDocumentPosition(e.target);

      const visibleFocusableElements = focusableElements.filter(
        focusableElement => {
          const isHidden =
            getComputedStyle(focusableElement).display === "none";

          if (isHidden) {
            return;
          }

          const isSummary = focusableElement.tagName === "SUMMARY";
          const focusableElementDetails =
            focusableElement.closest("details");
          const parentFocusableElementDetails =
            focusableElementDetails.parentElement.closest("details");
          const focusableElementDrawer =
            focusableElementDetails.querySelector(".js-drawer");
          const isThisDrawerOrDetails = focusableElementDrawer
            ? focusableElementDrawer === this.drawer
            : focusableElementDetails === this.details;

          return (
            isThisDrawerOrDetails ||
            (isSummary &&
              parentFocusableElementDetails.hasAttribute("open"))
          );
        }
      );

      const firstFocusableElement = visibleFocusableElements[0];
      const lastFocusableElement =
        visibleFocusableElements[visibleFocusableElements.length - 1];

      if (focusedElementDOMPosition >= 4) {
        firstFocusableElement.focus({
          preventScroll: true
        });
      } else {
        lastFocusableElement.focus({
          preventScroll: true
        });
      }
      isHandlingFocus = false;
    });
  }

  setInitialAccessibilityAttr() {
    const isDetailsOpen = this.details.hasAttribute("open");

    this.summary.setAttribute("role", "button");
    this.summary.setAttribute("aria-controls", this.drawer.id);
    this.summary.setAttribute("aria-expanded", isDetailsOpen);
  }
}

customElements.define("menu-drawer", MenuDrawer);

window.savedColourData = window.savedColourData || new Map();

class ColourDrawer extends MenuDrawer {
  constructor() {
    super();
    this.newToggleButtons = this.querySelectorAll('.drawer-opener');
    this.colorSelectors = this.querySelectorAll('.colour-selectors');
    this.toggleButtons = [...this.btnsCloseDrawer, ...this.newToggleButtons];
    this.availableColours = this.querySelectorAll('.drawer__colours-available-colours');
    this.removeButtons = this.querySelectorAll('.remove-colour-icon'); 
    this.selectedColours = this.querySelector('.drawer__title-selected-colours');
    this.coloursCount = parseInt(this.querySelector('[data-colours-count]').dataset.coloursCount);
    this.filters = this.querySelectorAll('.colour__drawer-filter');
    this.activeIndex = 1;
    this.inlineMessage = this.querySelector('.colour-drawer__inline-message');
    this.lockedColours = Array.from(this.querySelectorAll('.drawer__colours--locked'));
    this.atcButton = this.querySelector('.drawer__atc-button-wrapper button');
    this.warningMessage = this.querySelector('.drawer__warning-message');
    
    this.currentVariantId = null;
    this.currentColorsCount = null;
    this.variantChangeUnsubscriber = null;
    this.isSaving = false;
    this.isInitialized = false;

    const productDataScript = document.getElementById('product-data-json');
    let productData = {};
    if (productDataScript) {
      try {
        productData = JSON.parse(productDataScript.textContent);
      } catch (e) {
        console.error('Could not parse product-data-json:', e);
      }
    }
    
    const productMetafields = productData.product?.metafields || {};
    const limitDropdownColor = parseInt(productMetafields.limit_dropdown_color) || 0;
    let freeColours = 0;
    if (Array.isArray(productMetafields.list_of_free_colour)) {
      freeColours = productMetafields.list_of_free_colour.length;
    } else {
      freeColours = parseInt(productMetafields.list_of_free_colour) || 0;
    }
    
    const variants = productData.variants || [];
    const maxVariantCount = variants.reduce((max, v) => {
      const count = parseInt(v.metafields?.['kit-product-count']) || 0;
      return count > max ? count : max;
    }, 0);
    
    this.maxColoursCount = Math.max(maxVariantCount, limitDropdownColor + freeColours);
  }

  toggleDrawer(e) {
    if(e.target.classList.contains('drawer-opener')) {
      const removeButton = e.target.querySelector('.remove-colour-icon');
      if (removeButton && removeButton.style.display == 'block') {
        removeButton.click();
      }
    }
    super.toggleDrawer(e);
    setTimeout(() => {
      this.scrollActiveColourIntoView();
    }, 100);
  }
  
  restoreColorsForCurrentColorsCount() {
    if (!this.currentColorsCount) return;
    
    // First, try to find exact match
    let savedColorData = window.savedColourData.get(`colors-${this.currentColorsCount}`);
    
    // If no exact match, try to find colors from other color counts that can fit
    if (!savedColorData || savedColorData.length === 0) {
      const availableColorCounts = Array.from(window.savedColourData.keys())
        .map(key => key.replace('colors-', ''))
        .map(count => parseInt(count))
        .filter(count => !isNaN(count));
      
      // Try to find colors from any available color count
      for (const colorCount of availableColorCounts) {
        const otherColorData = window.savedColourData.get(`colors-${colorCount}`);
        if (otherColorData && otherColorData.length > 0) {
          savedColorData = otherColorData.filter(colorData => colorData.index <= this.currentColorsCount);
          if (savedColorData.length > 0) break;
        }
      }
    }
    
    if (!savedColorData || savedColorData.length === 0) return;
    
    this.waitForDOMReady(() => {
      this.performColorRestoration(savedColorData);
    });
  }

  waitForDOMReady(callback) {
    let attempts = 0;
    const maxAttempts = 20; // 1 second total (20 * 50ms)
    
    const checkInterval = setInterval(() => {
      attempts++;
      const colorElements = this.querySelectorAll('.drawer__colours');
      const availableColors = this.querySelectorAll('.drawer__colours-available-colours');
      
      if (colorElements.length > 0 && availableColors.length > 0) {
        clearInterval(checkInterval);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        callback();
      }
    }, 50);
  }

  handleVariantChange(eventData) {
    const newVariantId = eventData?.data?.variant?.id;
    
    setTimeout(() => {
      const newColorsCountElement = this.querySelector('[data-colours-count]');
      const newColorsCount = newColorsCountElement ? parseInt(newColorsCountElement.dataset.coloursCount) : null;
      
      if (newColorsCount && newColorsCount !== this.currentColorsCount) {
        // Save current colors before switching
        if (this.currentColorsCount) {
          this.saveCurrentColorsToGlobal();
        }
        
        // Update current values
        this.currentVariantId = newVariantId;
        this.currentColorsCount = newColorsCount;
        this.coloursCount = newColorsCount;
        
        // Restore colors for new color count
        setTimeout(() => {
          this.restoreColorsForCurrentColorsCount();
        }, 300);
      } else if (newVariantId !== this.currentVariantId) {
        this.currentVariantId = newVariantId;
      }
    }, 100);
  }

  initializeCurrentVariant() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      this.currentVariantId = variantInput.value;
    }
    
    this.currentColorsCount = this.coloursCount;
  }

  connectedCallback() {
    if (this.isInitialized) return;
    this.isInitialized = true;

    this.addToCart = this.closest('product-info')?.querySelector('.product-form button.product-form__submit[type="submit"]') || 
    this.closest('.product__content')?.querySelector('product-form-sets button[type="submit"]') || null;
    this.disabledButton = this.closest('product-info')?.querySelector('.product-form button.product-form__disabled') || 
    this.closest('.product__content')?.querySelector('product-form-sets button.product-form__disabled') || null;
    if(this.closest('.cart-item')) {
      this.colourChanger = this.querySelector('.drawer__colour-changer');
    }

    this.addToCart?.classList.add('hidden');
    this.disabledButton?.classList.remove('hidden');

    if (this.inlineMessage) {
      this.inlineMessage.addEventListener('click', this.handleUpgradeClick.bind(this));
    }

    if (typeof window.subscribe !== 'undefined') {
      this.variantChangeUnsubscriber = window.subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
        this.handleVariantChange(data);
        if (this.shouldOpenDrawerAfterUpgrade) {
          this.shouldOpenDrawerAfterUpgrade = false;
          const colourDrawer = document.querySelector('colour-drawer, colour-selector-inline');
          if (colourDrawer) {
            if (colourDrawer.tagName === 'COLOUR-SELECTOR-INLINE') {
              colourDrawer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              const summary = colourDrawer.querySelector('summary');
              if (summary) {
                summary.click();
              } else if (typeof colourDrawer.toggleDrawer === 'function') {
                colourDrawer.toggleDrawer();
              }
            }
          }
        }
      });
    }

    if (this.lockedColours.length > 0) {
      this.lockedColours.forEach(el => {
        el.addEventListener('click', this.handleUpgradeClick.bind(this));
      });
    }
    
    this.initializeCurrentVariant();
    
    setTimeout(() => {
      this.restoreColorsForCurrentColorsCount();
    }, 100);
    
    this.colorSelectors.forEach(colorSelector => {
      colorSelector.addEventListener("click", e => {
        e.preventDefault();
        
        const selector = e.target.closest('.colour-selectors');
        if (!selector) return;
        
        const input = selector.querySelector('input[name="colour"]');
        if (!input) return;
        
        const index = input.dataset.colourIndex;
        this.activeIndex = parseInt(index);
        this.scrollActiveColourIntoView();
      });
    });

    this.attachAvailableColoursListeners();

    this.removeButtons.forEach(removeButton => {
      removeButton.addEventListener("click", e => {
        e.stopPropagation();
        e.preventDefault();

        const parent = removeButton.closest('.drawer__colours');
        const input = parent.querySelector('input[name="colour"]');
        const index = parseInt(input.dataset.colourIndex);
        this.activeIndex = index;

        const activeElements = this.querySelectorAll(`.drawer__colours:has(input[data-colour-index="${this.activeIndex}"])`);
        activeElements.forEach((activeElement, index) => { 
          let inputValue = activeElement.querySelector('input[name="colour"]').value;
          let colourCount = parseInt(this.querySelector(`.drawer__colours-available-colours:has(input[value="${inputValue}"]) .drawer__colour-count`).textContent);
          let countDiv = this.querySelector(`.drawer__colours-available-colours:has(input[value="${inputValue}"]) .drawer__colour-count`);
          if (colourCount <= this.coloursCount && colourCount > 0 && index == 0) {
            countDiv.style.display = 'flex';
            countDiv.textContent = colourCount - 1;
          }
          if (colourCount === 0) {
            countDiv.style.display = 'none';
          }
          activeElement.style.backgroundImage = '';
          activeElement.querySelector('input[name="colour"]').value = '';
          activeElement.querySelector('.drawer__colour-selection-title').textContent = '';
          activeElement.querySelector('.drawer__colour-selection-title').style.display = 'none';
          activeElement.querySelector('.drawer__colour-colour-selection-tip').style.display = 'block';
          activeElement.querySelector('.remove-colour-icon').style.display = 'none';
          activeElement.classList.remove('drawer__colours--selected');
        });
        this.updateCount();
        this.updateUpgradePrompt();
        this.updateFormData(index, '');
        
        if (!this.isSaving) {
          this.saveCurrentColorsToGlobal();
        }
        
        if(!this.addToCart?.classList.contains('hidden') || this.disabledButton.classList.contains('hidden') || this.colourChanger?.classList.contains('active')) {
          this.addToCart?.classList.add('hidden');
          this.disabledButton?.classList.remove('hidden');
          this.colourChanger?.classList.remove('active');
        }
      });
    });

    // Dropdown filter logic for colour drawer
    const dropdown = this.querySelector('.js-colour-filter-select');
    if (dropdown) {
      if(dropdown.options.length <= 2){
        dropdown.style.display = 'none';
      }
      dropdown.addEventListener('change', (e) => {
        const selected = e.target.value;
        this.querySelectorAll('.drawer__colours-available-colours').forEach(el => {
          if (selected === 'all_items' || el.classList.contains(selected)) {
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
      });
    }

    this.filters.forEach(filter => {
      const filterValue = filter.dataset.colourFilter;
      const filterElements = this.querySelectorAll(`.drawer__colours-available-colours:not(.${filterValue})`);
      const visibleElements = this.querySelectorAll(`.drawer__colours-available-colours.${filterValue}`);
      if(visibleElements.length === 0) {
        filter.style.display = 'none';
      }

      filter.addEventListener("click", e => {
        document.querySelectorAll('.colour__drawer-filter').forEach(filter => {
          filter.classList.remove('active');
        });
        filter.classList.add('active');
        e.preventDefault();
        filterElements.forEach(element => {
          element.style.display = 'none';
        });
        visibleElements.forEach(element => {
          element.style.display = 'block';
        });
      });
    });

    const backMessage = this.querySelector('.colour-drawer__back-message');
    if (backMessage) {
      backMessage.addEventListener('click', (e) => {
        this.handleUpgradeClick(e);
        if (!this.shouldOpenDrawerAfterUpgrade) {
          this.btnsCloseDrawer[0]?.click();
        }
      });
    }

    if (this.atcButton) {
      this.atcButton.addEventListener('click', this.addToCartButtonClick.bind(this));
    }

    // Load additional products from collection
    this.loadAllProducts();
  }

  async loadAllProducts() {
    const container = this.querySelector('.drawer__colours-collection');
    if (!container) return;
    
    const collectionHandle = container.dataset.collectionHandle;
    const totalProducts = parseInt(container.dataset.totalProducts, 10);
    if (!collectionHandle || !totalProducts) return;
    
    const pageSize = 250;
    const totalPages = Math.ceil(totalProducts / pageSize);
    
    // If only one page, no need to load additional products
    if (totalPages <= 1) return;
    
    // Tags/titles to exclude
    const excludeTags = ['hide-from-colour-drawer', 'hide_collection', 'bundle', 'hideproduct'];
    const excludeTitles = ['Bestsellers', 'Free', 'Halloween Powder Trio', '6 Piece Powder Pack', 'Powder Trio Pack'];
    
    const shouldExcludeProduct = (product) => {
      if (excludeTitles.some(title => product.title.includes(title))) return true;
      if (product.tags && excludeTags.some(tag => product.tags.includes(tag))) return true;
      return false;
    };
    
    const getFilterGroups = (tags) => {
      if (!tags) return '';
      return tags
        .filter(tag => tag.includes('_'))
        .map(tag => tag.toLowerCase().replace(/\s+/g, '-'))
        .join(' ');
    };
    
    const createProductElement = (product) => {
      const groups = getFilterGroups(product.tags);
      const variantId = product.variants[0]?.id || '';
      const imageUrl = product.images[0]?.src || '';
      const productId = product.id || `dynamic-${variantId}`;
      const imageCount = (product.images && product.images.length) || 0;
      const hasMagnifiedImages = imageCount > 0;

      const escapeHtml = (str) => {
        if (!str) return '';
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      };
      const safeTitle = escapeHtml(product.title);
      const safeImageUrl = (url) => (url || '').replace(/"/g, '&quot;');

      const swiperSlidesHtml = (product.images || [])
        .map((img) => {
          const src = safeImageUrl(img.src);
          const alt = escapeHtml(img.alt || product.title);
          return `<div class="swiper-slide"><img src="${src}" alt="${alt}" width="530" loading="lazy" decoding="async"></div>`;
        })
        .join('');

      const magnifiedImagesHtml = hasMagnifiedImages
        ? `
        <div class="magnified-images">
          <button
            type="button"
            class="magnified-images__trigger button button--icon"
            aria-label="View enlarged images of ${safeTitle}"
            aria-haspopup="dialog"
            data-product-title="${safeTitle}"
            data-cta-text="Add to Set"
          >
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 8V14M14 11L8 11M20 20L16.05 16.05M18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
          <template class="magnified-images__product-template">
            <swiper-component
              class="swiper"
              style="--slides-per-view-desktop: 1; --space-between-desktop: 0px; --space-between-mobile: 0px;"
              data-swiper-id="${productId}"
              data-swiper-options='{"swiperName":"carousel","swiperId":"${productId}","slideCount":${imageCount},"spaceBetweenDesktop":0,"spaceBetweenMobile":0,"slidesPerViewDesktop":1,"slidesPerViewTablet":1,"slidesPerViewMobile":1,"loop":true,"centeredSlides":true,"centerInsufficientSlides":true,"centeredSlidesBounds":true,"grabCursor":true,"navigation":{"prevEl":".swiper-button--prev-${productId}","nextEl":".swiper-button--next-${productId}"},"pagination":"render_bullet"}'
            >
              <div class="swiper-wrapper">${swiperSlidesHtml}</div>
              <div class="swiper-pagination swiper-pagination--${productId}"></div>
              <div class="swiper-buttons swiper-buttons--${productId}">
                <button class="swiper-button swiper-button--prev swiper-button--prev-${productId}" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>
                </button>
                <button class="swiper-button swiper-button--next swiper-button--next-${productId}" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
                </button>
              </div>
            </swiper-component>
          </template>
        </div>
        `
        : '';

      const div = document.createElement('div');
      div.className = `drawer__colours drawer__colours-available-colours ${groups} all_items`;
      div.setAttribute('href', product.url);
      div.style.backgroundImage = 'none';

      div.innerHTML = `
        <div class="drawer__colour-wrapper lazy-background" data-bg="url('${safeImageUrl(imageUrl)}')" style="background-image: url('${safeImageUrl(imageUrl)}')">
          <label class="drawer__colour">
            <input type="radio" name="${safeTitle}" value="${variantId}" class="hidden" id="${variantId}">
          </label>
        </div>
        <div class="drawer__colour-title">${safeTitle}</div>
        <div class="drawer__colour-count" style="display:none;">0</div>
        ${magnifiedImagesHtml}
      `;

      return div;
    };
    
    // Load additional pages
    for (let page = 2; page <= totalPages; page++) {
      try {
        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=${pageSize}&page=${page}`);
        const data = await response.json();
        
        if (data.products && data.products.length > 0) {
          data.products.forEach(product => {
            if (!shouldExcludeProduct(product)) {
              container.appendChild(createProductElement(product));
            }
          });
        }
      } catch (error) {
        console.error(`Error loading page ${page}:`, error);
      }
    }
    
    // Re-initialize lazy loading if applicable
    if (typeof window.lazyLoadInstance !== 'undefined') {
      window.lazyLoadInstance.update();
    }
    
    // Reinitialize availableColours and attach listeners to new elements only
    const previousCount = this.availableColours.length;
    this.availableColours = this.querySelectorAll('.drawer__colours-available-colours');
    const newColours = Array.from(this.availableColours).slice(previousCount);
    
    // Attach listeners to newly added elements
    this.attachAvailableColoursListeners(newColours);
    
    container.dispatchEvent(new CustomEvent('all-products-loaded'));
  }

  attachAvailableColoursListeners(coloursToAttach = null) {
    const colours = coloursToAttach || this.availableColours;
    
    colours.forEach((colour) => {
      colour.addEventListener("click", e => {
        let activeElements = this.querySelectorAll(`.drawer__colours:has(input[data-colour-index="${this.activeIndex}"])`);
        const activeInput = activeElements[0]?.querySelector('input[name="colour"]');
        let colourCount = parseInt(colour.querySelector('.drawer__colour-count').textContent);
        let countDiv = colour.querySelector('.drawer__colour-count');

        if (activeInput && activeInput.value) {
          this.activeIndex = this.activeIndex + 1;
          while (this.querySelector(`input[data-colour-index="${this.activeIndex}"]`)?.value && this.activeIndex <= this.coloursCount) {
            this.activeIndex = this.activeIndex + 1;
            console.log('Searching for activeIndex')
          }
        }

        activeElements = this.querySelectorAll(`.drawer__colours:has(input[data-colour-index="${this.activeIndex}"])`);

        if (activeElements.length === 0 || this.activeIndex > this.coloursCount ) {
          // if(!this.closest('.cart-item')){
          //   this.btnsCloseDrawer[0].click();
          // }
          if(this.warningMessage && !this.warningMessage.classList.contains('active')) {
            this.warningMessage.classList.add('active');
            setTimeout(() => {
              this.warningMessage.classList.remove('active');
            }, 5000);
          }
          return;
        }

        activeElements.forEach(activeElement => {
          activeElement.style.backgroundImage = colour.querySelector('.drawer__colour-wrapper').style.backgroundImage || colour.querySelector('.drawer__colour-wrapper').getAttribute('data-bg');
          activeElement.querySelector('input[name="colour"]').value = colour.querySelector('input').value;
          activeElement.querySelector('.drawer__colour-colour-selection-tip').style.display = 'none';
          activeElement.querySelector('.drawer__colour-selection-title').textContent = colour.querySelector('.drawer__colour-title').textContent;
          activeElement.querySelector('.drawer__colour-selection-title').style.display = 'block';
          activeElement.querySelector('.remove-colour-icon').style.display = 'block';
          activeElement.classList.add('drawer__colours--selected');
          if (colourCount <= this.coloursCount) {
            countDiv.style.display = 'flex';
            countDiv.textContent = colourCount + 1;
          }
        });

        this.updateFormData(this.activeIndex, colour.querySelector('input').value);
        
        if (!this.isSaving) {
          this.saveCurrentColorsToGlobal();
        }

        const nextElement = Array.from(this.querySelectorAll(`.drawer__colours:has(input[name="colour"])`))
          .find(element => {
            if (parseInt(element.querySelector('input[name="colour"]').dataset.colourIndex) === this.activeIndex) {
              return false;
            }
            return element.querySelector('input[name="colour"]').value === '';
          });

        if (nextElement) {
          const nextIndex = parseInt(nextElement.querySelector('input[name="colour"]').dataset.colourIndex);
          this.activeIndex = nextIndex;
          nextElement.querySelector('.drawer__colour-colour-selection-tip').style.display = 'block';
        } else {
          // if(!this.closest('.cart-item')){
          //   this.btnsCloseDrawer[0].click();
          // }
          this.colourChanger?.classList.add('active');
          this.addToCart?.classList.remove('hidden');
          this.disabledButton?.classList.add('hidden');
          if (this.tagName === 'COLOUR-SELECTOR-INLINE') {
            this.addToCart?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        this.updateCount();
        if (this.selectedCount === this.coloursCount) {
          // if(!this.closest('.cart-item')){
          //   this.btnsCloseDrawer[0]?.click();
          // }
          this.updateUpgradePrompt();
        }
      });
    });
  }

  saveCurrentColorsToGlobal() {
    if (!this.currentColorsCount || this.isSaving) return;
    
    this.isSaving = true;
    
    // Get unique selected colors (avoid counting duplicates)
    const uniqueColorData = new Map();
    
    this.querySelectorAll('.drawer__colours--selected').forEach(selectedElement => {
      const input = selectedElement.querySelector('input[name="colour"]');
      const titleElement = selectedElement.querySelector('.drawer__colour-selection-title');
      
      if (input && input.value && titleElement) {
        const index = parseInt(input.dataset.colourIndex);
        
        if (!uniqueColorData.has(index)) {
          uniqueColorData.set(index, {
            index: index,
            variantId: input.value,
            title: titleElement.textContent.trim(),
            backgroundImage: selectedElement.style.backgroundImage
          });
        }
      }
    });
    
    const currentColorData = Array.from(uniqueColorData.values());
    
    if (currentColorData.length > 0) {
      window.savedColourData.set(`colors-${this.currentColorsCount}`, currentColorData);
    }
    
    setTimeout(() => {
      this.isSaving = false;
    }, 100);
  }

  performColorRestoration(savedColorData) {
    const colourCounts = {};
    savedColorData.forEach(colorData => {
      if (!colourCounts[colorData.variantId]) {
        colourCounts[colorData.variantId] = 0;
      }
      colourCounts[colorData.variantId]++;
    });
  
    const colorsToRestore = savedColorData.filter(colorData => colorData.index <= this.coloursCount);
    
    colorsToRestore.forEach((colorData) => {
      const targetElements = this.querySelectorAll(`.drawer__colours:has(input[data-colour-index="${colorData.index}"])`);
      
      if (targetElements.length === 0) return;
      
      targetElements.forEach(activeElement => {
        activeElement.style.backgroundImage = colorData.backgroundImage;
        activeElement.querySelector('input[name="colour"]').value = colorData.variantId;
        activeElement.querySelector('.drawer__colour-colour-selection-tip').style.display = 'none';
        activeElement.querySelector('.drawer__colour-selection-title').textContent = colorData.title;
        activeElement.querySelector('.drawer__colour-selection-title').style.display = 'block';
        activeElement.querySelector('.remove-colour-icon').style.display = 'block';
        activeElement.classList.add('drawer__colours--selected');
        
        const availableColour = this.querySelector(`.drawer__colours-available-colours:has(input[value="${colorData.variantId}"])`);
        if (availableColour) {
          const countDiv = availableColour.querySelector('.drawer__colour-count');
          if (countDiv) {
            countDiv.style.display = 'flex';
            countDiv.textContent = colourCounts[colorData.variantId];
          }
        }
      });
      
      this.updateFormData(colorData.index, colorData.variantId);
    });
    
    this.updateCount();
    
    const restoredCount = colorsToRestore.length;
    if (restoredCount < this.coloursCount) {
      this.activeIndex = restoredCount + 1;
    } else {
      this.addToCart?.classList.remove('hidden');
      this.disabledButton?.classList.add('hidden');
      this.colourChanger?.classList.add('active');
    }
    
    // Save the restored colors for the current color count if they don't exist yet
    setTimeout(() => {
      const currentSavedColors = window.savedColourData.get(`colors-${this.currentColorsCount}`);
      if (!currentSavedColors || currentSavedColors.length === 0) {
        this.saveCurrentColorsToGlobal();
      }
    }, 100);

    this.updateCount();
    this.updateUpgradePrompt(); 
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
    this.isInitialized = false;
  }

  updateCount(){
    const selectedCount = this.querySelectorAll('.drawer__colours--selected').length/2;
    this.selectedCount = selectedCount;
    document.querySelectorAll('.drawer__title-selected-colours').forEach(element => {
      element.textContent = selectedCount;
    });
  }

  updateUpgradePrompt() {
    const selectedCount = this.selectedCount || 0;
    const allowedCount = parseInt(this.querySelector('.drawer__colours-wrapper').dataset.coloursCount);
  
    const showUpgrade = selectedCount === allowedCount;
  
    if (this.inlineMessage) {
      this.inlineMessage.style.display = showUpgrade ? 'block' : 'none';
    }
  
    this.querySelectorAll('.drawer__colours--locked').forEach(el => {
      el.style.display = showUpgrade ? 'block' : 'none';
    });

    this.querySelectorAll('.drawer__atc-button-wrapper').forEach(el => {
      el.style.display = showUpgrade ? 'block' : 'none';
    });

    document.querySelectorAll('.product__variant-picker-sets__option').forEach(el => {
      el.style.display = showUpgrade ? 'block' : 'none';
    });
  }

  handleUpgradeClick(e) {
    e.preventDefault();
    const variantPickerOption = document.querySelector('.product__variant-picker-sets__option');
    if (variantPickerOption) {
      variantPickerOption.click();
    }
  }

  scrollActiveColourIntoView() {
    const activeElements = this.querySelectorAll(`.drawer__colours:has(input[data-colour-index="${this.activeIndex}"])`);
    if (activeElements.length > 0) {
      activeElements.forEach(activeElement => {
        const rect = activeElement.getBoundingClientRect();
        const isInViewport = (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );

        // Only scroll if the element is not visible in viewport
        if (!isInViewport || activeElement.classList.contains('colour-selectors--drawer')) {
          activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  updateFormData(index, id) {
    const parentInput = this.querySelector(`.product__info-row [data-colour-index="${index}"]`);
    const parentWrapper = parentInput?.closest('.drawer__colours');
    const titleElement = parentWrapper?.querySelector('.drawer__colour-selection-title');
    const mainVariantId = this.querySelector('input#main_variant_id')
    const allTitleInputs = this.closest('[data-main-product]')?.querySelectorAll('input[id^="colour_title_"]') || this.querySelectorAll('input[id^="colour_title_"]');
    const highlightedProductGroupInputs = this.closest('[data-main-product]')?.querySelectorAll('input#_group_id') || this.querySelectorAll('input#_group_id');
    const inputId = this.closest('[data-main-product]')?.querySelector(`input#id_${index}.form-input`) || this.querySelector(`input#id_${index}.form-input`);
    const titleInput = this.closest('product-info')?.querySelector(`input#colour_title_${index}`) || this.querySelector(`input#colour_title_${index}`);

    if(inputId){
      inputId.value = id;
    }

    if(titleElement) {
      titleInput.value = titleElement.textContent.trim();
    }

    if(highlightedProductGroupInputs.length > 0){
      highlightedProductGroupInputs.forEach(input => {
        input.value = mainVariantId.value;
        for(let i = 0; i < allTitleInputs.length; i++) {
          input.value = `${input.value}_${allTitleInputs[i].value}`;
        }
      })
    }
  }

  addToCartButtonClick() {
    if(this.closest('line-colour-changer')) {
      return;
    }
    document.querySelector('.product-form__submit')?.click();
    console.log('addToCartButtonClick');
    this.btnsCloseDrawer[0]?.click();
  }
}

customElements.define("colour-drawer", ColourDrawer);

/**
 * Inline variant of the colour drawer. Reuses all of the ColourDrawer
 * selection/restore/form-data logic, but renders the panel inline on the page
 * (below the product form) instead of as a slide-out drawer. The <details> is
 * kept permanently open and the slide-out toggle is disabled.
 */
class ColourSelectorInline extends ColourDrawer {
  toggleDrawer(e) {
    if (e?.target?.classList?.contains('drawer-opener')) {
      const removeButton = e.target.querySelector('.remove-colour-icon');
      if (removeButton && removeButton.style.display === 'block') {
        removeButton.click();
      }
    }
  }

  connectedCallback() {
    this.details?.setAttribute('open', '');
    super.connectedCallback();
  }

  // Avoid scrolling the whole page when a slot becomes active inline.
  scrollActiveColourIntoView() {}
}

customElements.define("colour-selector-inline", ColourSelectorInline);

class lineColourChanger extends ColourDrawer{
  constructor() {
    super();
    this.newToggleButtons = this.querySelectorAll('.cart-colour-drawer-opener');
    this.toggleButtons = [...this.btnsCloseDrawer, ...this.newToggleButtons]; 
    this.selectedTitles = Array.from(this.colorSelectors)
      .slice(0, Math.floor(this.colorSelectors.length / 2))
      .map(selector => {
        return selector.querySelector('input[name="colour"]').dataset.productTitle;
      });
    initLazyBackgrounds();
  }

  connectedCallback() {
    this.newToggleButtons.forEach(toggleButton => {
      toggleButton.addEventListener("click", (event) => {
        event.stopPropagation();
        this.activeIndex = 1;
        this.selectedTitles.forEach((title, index) => {
          this.availableColours.forEach((colour) => {
            const input = colour.querySelector('input');
            if(input.name === title) {
              colour.click();
            }
          })
        });

        this.toggleDrawer(event);
      });
    });
    
    this.atcButton.addEventListener('click', this.updateCartDataHandler.bind(this));

  }

  updateCartDataHandler(e) {
    e.target.classList.remove('active');
    e.preventDefault();
    e.stopPropagation();
    this.debouncedUpdateCart(e);
  }

  debouncedUpdateCart = debounce((e) => {
    this.updateCartData(e);
  }, 300);

  async updateCartData(e){

    this.querySelector('.drawer__content').classList.add('drawer-loading');
    this.cart = this.closest('cart-drawer');
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData();
    const groupId = this.querySelector('.nail-set__form-data input[name="properties[_group_id]"]').value;
    let qtyId = Math.random().toString(36).substring(2, 7);
    const additionalProducts = this.querySelectorAll('.nail-set__form-data input[id^="id_"]');
    let options = this.querySelectorAll('.nail-set__form-data input[id^="colour_title_"]');
    const addOns = this.querySelectorAll('.nail-set__form-data input[id^="free_product_id_"]');
    const mainVariantId = this.querySelector('input#main_variant_id').value;
    const lineQuantity = this.closest('.cart-item')?.querySelector('quantity-input .quantity__input')?.value || 1;

    const item = {
      id: mainVariantId,
      quantity: parseInt(lineQuantity) || 1,
      properties: {
        '_item_type': 'main',
        '_group_id': groupId,
        '_qtyId': qtyId,
        '_randomId': Math.random().toString(36).substring(2, 7)
      }
    }
    
    if (options.length > 0) {
      options.forEach(option => {
        item[option.name] = option.value;
      });
    }
    const items = [];
    
    additionalProducts.forEach((product, index) => {
      const variantId = product.value;
      
      if (variantId) {
        // Get the colour index from the product's data attribute
        const colourIndex = product.dataset.colourIndex || (index + 1);
        
        // Check if this color slot is marked as free
        const colorSelector = this.querySelector(`.colour-selectors[data-slot-index="${colourIndex}"]`);
        const isFreeColor = colorSelector?.classList.contains('free_colour');
        
        const itemProperties = {
          '_item_type': 'subitem',
          '_group_id': groupId,
          '_qtyId': qtyId,
          '_randomId': Math.random().toString(36).substring(2, 7)
        };
        
        // Add _free_color property if this is a free color slot
        if (isFreeColor) {
          itemProperties['_free_color'] = 'true';
        }
        
        items.push({
          id: variantId,
          quantity: parseInt(lineQuantity) || 1,
          properties: itemProperties
        });
      }
    });

    if(addOns.length > 0) {
      addOns.forEach(addOn => {
        const variantId = addOn.value;
        
        if (variantId) {
          items.push({
            id: variantId,
            quantity: parseInt(lineQuantity) || 1,
            properties: {
              '_item_type': 'subitem',
              '_group_id': groupId,
              '_qtyId': qtyId,
              '_randomId': Math.random().toString(36).substring(2, 7)
            }
          });
        }
      });
    
    }

    items.push(item);
    
    for (let i = 0; i < items.length; i++) {
      Object.entries(items[i]).forEach(([key, value]) => {
        if (key === 'properties') {
          Object.entries(value).forEach(([propKey, propValue]) => {
            formData.append(`items[${i}][properties][${propKey}]`, propValue);
          });
        } else {
          formData.append(`items[${i}][${key}]`, value);
        }
      });
    }

    if (this.cart) {
      formData.append(
        "sections",
        this.cart
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = formData;
    const parent_id = this.getAttribute('data-parent-line-id');
    const cartItems = this.closest('cart-drawer-items');
    const lineItem = cartItems?.querySelector(`[data-parent-line-id="${parent_id}"]`);
    
    let subItems = lineItem?.querySelector('.cart-item__quantity').dataset.subIds
    const subItemsObj = {};

    if(subItems && subItems.length > 0){
      const itemsArray = Array.isArray(subItems) ? subItems : subItems.split(',');

      // Create object with each subItem as key and quantity as value
      itemsArray.forEach(item => {
        if (item && item.trim()) {
          subItemsObj[item.trim()] = 0;
        }
      });

      const body = JSON.stringify({
        updates: subItemsObj,
        sections: this.cart.getSectionsToRender().map(section => section.section),
        sections_url: window.location.pathname,
      });
      fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body }
      })
        .then(response => response.text())
        .then(() => {
          return fetch(`${routes.cart_add_url}`, config);
        })
        .then(response => response.json())
        .then(response => {
          this.cart.renderContents(response);
          this.querySelector('.drawer__content').classList.remove('drawer-loading');
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          this.querySelector('.drawer__content').classList.remove('drawer-loading');
        });
    }
  }
}

customElements.define("line-colour-changer", lineColourChanger);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    window.addEventListener("resize", e => {
      const isMobileDrawer = this.classList.contains("mobile-drawer");

      if (!isMobileDrawer) {
        return;
      }

      const isDesktop = window.innerWidth < tabletWidth;
      const isMenuOpen =
        this.details.classList.contains("menu-opening");

      if (isDesktop || !isMenuOpen) {
        return;
      }

      this.instantlyHideDrawer();
    });
  }

  instantlyHideDrawer() {
    super.instantlyHideDrawer();
  }

  toggleDrawer() {
    const isDrawerTransitioning = this.details.classList.contains(
      "drawer-transitioning"
    );

    const drawerButton = this.querySelector(".drawer__button");
    // if drawerButton has .menu-is-open class and if header has .menu-open class, drawer is open
    // so when drawerButton with .menu-is-open class is clicked, remove .menu-open class from header
    if (drawerButton.classList.contains("menu-is-open")) {
      header.classList.remove("menu-open");
      drawerButton.classList.remove("menu-is-open");
      // body scroll lock for iphones - start
      body.style.removeProperty("position");
      window.scrollTo(0, this.scrollTopValue);
    } else {
      this.scrollTopValue = window.scrollY;
      // body.style.position = "fixed"; / this causes scroll to top - buggy code
      // body scroll lock for iphones - end
      header.classList.add("menu-open");
      drawerButton.classList.add("menu-is-open");
    }

    // header.classList.toggle('menu-open');
    super.toggleDrawer();

    this.querySelectorAll(".drawer__menu-item").forEach(item => {
      item.classList.toggle("is--visible");
    });
    this.querySelectorAll(".drawer__subnav-item").forEach(item => {
      item.classList.toggle("is--visible");
    });
  }

  toggleTrapFocus() {
    super.toggleTrapFocus(this.details);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class DesktopDrawer extends MenuDrawer {
  constructor() {
    super();

    window.addEventListener("resize", e => {
      const isDesktop = window.innerWidth < tabletWidth;
      const isMenuOpen =
        this.details.classList.contains("menu-opening");

      if (!isDesktop || !isMenuOpen) {
        return;
      }

      this.instantlyHideDrawer();
    });
  }
}

customElements.define("desktop-drawer", DesktopDrawer);

class SearchDrawer extends MenuDrawer {
  constructor() {
    super();

    window.addEventListener("resize", e => {
      const isMenuOpen =
        this.details.classList.contains("menu-opening");

      if (!isMenuOpen) {
        return;
      }
    });

    // get button element
    this.btn = this.querySelector(".drawer__button");
    // if this button clicked, close all other drawers
    this.btn.addEventListener("click", () => {
      const headerDrawerDetails = document.querySelector("header-drawer details");
      if (headerDrawerDetails) {
        headerDrawerDetails.removeAttribute("open");
        headerDrawerDetails.classList.remove("menu-opening");
      }
    });
  }
}
customElements.define("search-drawer", SearchDrawer);

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach(video => video.pause());
  document.querySelectorAll("product-model").forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

// unpause all media
function unpauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "playVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach(video => {
    video.contentWindow.postMessage('{"method":"play"}', "*");
  });
  // document.querySelectorAll('video').forEach(video => video.play());

  // document.querySelectorAll("video").forEach(video => {
  //   let playPromise = video.play();
  //   if (playPromise !== undefined) {
  //     playPromise
  //       .then(_ => {
  //         // Automatic playback started!
  //         // Show playing UI.
  //         // video.play();
  //       })
  //       .catch(error => {
  //         // Auto-play was prevented
  //         // Show paused UI.
  //         // if paused, play
  //         video.play();
  //       });
  //   } else {
  //     // Show paused UI.
  //   }
  // });

  document.querySelectorAll("product-model").forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.play();
  });
}

const fetchConfig = (type = "json") => {
  return {
    method: "POST",
    headers: {
      "Content-Type": `application/${type}`,
      "Accept": `application/${type}`
    }
  };
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const eventTarget = event.target.name
      ? event.target
      : event.target.closest("button");

    const previousValue = this.input.value;

    eventTarget.name === "increment"
      ? this.input.stepUp()
      : this.input.stepDown();

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;

    button.addEventListener("click", () => {
      const modal = document.querySelector(
        this.getAttribute("data-modal")
      );

      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.dialogHolder = this.querySelector('[role="dialog"]');
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    this.addEventListener("keyup", event => {
      if (event.code?.toUpperCase() === "ESCAPE" && !event.target.closest("age-verification-popup")) {
        this.hide();
      }
    });

    this.addEventListener("click", event => {
      this.hide();
    });

    // Prevent closing the modal dialog when clicking inside the dialog holder
    this.dialogHolder.addEventListener("click", event => {
      event.stopPropagation();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    bodyScroll.lock(this.dialogHolder);
    this.setAttribute("open", "");
    trapFocus(this, this.dialogHolder);
    if (this.querySelector('video')) {
      this.querySelector('video').play();
    }
    // window.pauseAllMedia();
  }

  hide() {
    bodyScroll.unlock(this.dialogHolder);
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    if(!document.querySelector('cart-drawer.is-visible')) {
      document.body.style.overflow = "";
    }
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    if (this.querySelector('video')) {
      this.querySelector('video').pause();
    }
    // window.unpauseAllMedia(); // Commenting this out as it can be intrusive
  }
}

customElements.define("modal-dialog", ModalDialog);

function isIOS() {
  return (
    /iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator/.test(
      navigator.platform
    ) ||
    (navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1)
  );
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector(
          "template"
        ).content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (isIOS()) {
        deferredElement.controls = true;
      }

      deferredElement.play && deferredElement.play();

      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

/**
 * Additions
 */

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.localizationInputElements = this.querySelectorAll(
      '[name="country_code"], [name="language_code"]'
    );

    this.localizationInputElements.forEach(inputElement => {
      inputElement.addEventListener("input", () => {
        this.form.submit();
      });
    });
  }
}

customElements.define("localization-form", LocalizationForm);

class AccordionDefault extends HTMLElement {
  constructor() {
    super();

    this.hideMultiple = this.hasAttribute("data-hide-multiple");
    this.summaryElements = this.querySelectorAll("summary");

    this.setInitialAccessibilityAttr();

    this.addEventListener("click", e => {
      let isBtn = e.target.classList.contains("js-btn");

      if (!isBtn) {
        isBtn = e.target.closest("summary.js-btn");
      }

      if (!isBtn) return;

      e.preventDefault();

      this.toggleDropdown(
        e.target.classList.contains("js-btn")
          ? e.target
          : e.target.closest("summary")
      );
      this.collapseInactiveItems();
    });

    this.addEventListener("keydown", e => {
      const isEscapeKey = e.key === "Escape";

      if (!isEscapeKey) {
        return;
      }

      const closestOpenDetails = document.activeElement.closest(
        "details.is-active"
      );

      if (!closestOpenDetails) {
        return;
      }

      const btn = closestOpenDetails.querySelector("summary");

      if (this.closest('menu-drawer').classList.contains('facets__drawer')) {
        this.closest('menu-drawer').toggleDrawer();
        return;
      }

      this.toggleDropdown(btn);
      this.collapseInactiveItems();
    });
  }

  collapseInactiveItems() {
    if (!this.hideMultiple) return;
    const allSummaryElements = document.querySelectorAll(
      "accordion-default summary"
    );
    allSummaryElements.forEach(summary => {
      const accordionDefault = summary.closest("accordion-default");
      accordionDefault.toggleDropdown(summary, true);
    });
  }

  toggleDropdown(btn, forceClose) {
    const dropdown = btn.nextElementSibling;
    const isDropdownTransitioning = dropdown.classList.contains(
      "is-transitioning"
    );

    if (isDropdownTransitioning) {
      return;
    }

    const details = btn.parentElement;
    const accordionContainer = details.closest(".product__accordion");

    if (forceClose) {
      details.classList.remove("is-active");
      details.removeAttribute("open");
      btn.setAttribute("aria-expanded", false);
      dropdown.style.height = "0px";
      return;
    }

    details.classList.toggle("is-active");

    const isDetailsActive = details.classList.contains("is-active");

    btn.setAttribute("aria-expanded", isDetailsActive);

    if (isDetailsActive) {
      details.setAttribute("open", "");

      dropdown.style.height = `${dropdown.scrollHeight}px`;
      setTimeout(() => {
        if (accordionContainer) {
          const rect = accordionContainer.getBoundingClientRect();
          const scrollY = window.scrollY + rect.top - 150;

          window.scrollTo({
            top: scrollY,
            behavior: "smooth"
          });
        }
      }, 150);
    } else {
      dropdown.style.height = `${dropdown.scrollHeight}px`;

      setTimeout(() => {
        dropdown.style.height = "0px";
      }, 0);
    }

    dropdown.classList.add("is-transitioning");
    dropdown.addEventListener(
      "transitionend",
      handleHeightTransition
    );

    function handleHeightTransition(e) {
      dropdown.removeEventListener(
        "transitionend",
        handleHeightTransition
      );
      dropdown.classList.remove("is-transitioning");

      if (isDetailsActive) {
        dropdown.style.height = "auto";
        return;
      }

      details.removeAttribute("open");
      btn.focus();
    }
  }

  setInitialAccessibilityAttr() {
    this.summaryElements.forEach(summaryElement => {
      const detailsElement = summaryElement.parentElement;
      const dropdown = summaryElement.nextElementSibling;
      const isDetailsOpen = detailsElement.hasAttribute("open");

      summaryElement.setAttribute("role", "button");
      summaryElement.setAttribute("aria-controls", dropdown.id);
      summaryElement.setAttribute("aria-expanded", isDetailsOpen);
    });
  }
}

customElements.define("accordion-default", AccordionDefault);

const nav = document.querySelector(".js-nav");

nav?.addEventListener("click", function (e) {
  const isHoverDisabled = matchMedia("(hover: none)").matches;
  const isLink = e.target.classList.contains("js-nav-link");

  if (!isHoverDisabled || !isLink) {
    return;
  }

  const link = e.target;
  const linkItem = link.parentElement;
  const linksList = linkItem.parentElement;
  const activeLinkItem = linksList.querySelector(
    ".js-nav-item.is-active"
  );
  const hasDropdown = linkItem.classList.contains("has-dropdown");

  if (activeLinkItem !== linkItem) {
    activeLinkItem?.classList.remove("is-active");
  }

  if (!hasDropdown) {
    return;
  }

  e.preventDefault();

  linkItem.classList.toggle("is-active");
});

document.addEventListener("click", function (e) {
  const targetActiveLinkItem = e.target.closest(
    ".js-nav-item.is-active"
  );

  if (targetActiveLinkItem) {
    return;
  }

  const activeLinkItems = document.querySelectorAll(
    ".js-nav-item.is-active"
  );

  if (activeLinkItems.length == 0) {
    return;
  }

  activeLinkItems.forEach(activeLinkItem => {
    activeLinkItem.classList.remove("is-active");
  });
});

let navItems = document.querySelectorAll(
  ".js-nav-item.has-dropdown:not(.dropdown)"
);

window.addEventListener("shopify:section:load", function () {
  navItems = document.querySelectorAll(
    ".js-nav-item.has-dropdown:not(.dropdown)"
  );
});

["DOMContentLoaded", "resize"].forEach(eventType => {
  window.addEventListener(eventType, () => {
    navItems = document.querySelectorAll(
      ".js-nav-item.has-dropdown:not(.dropdown)"
    );
    navItems.forEach(navItem => {
      const dropdown = navItem.querySelector(".js-dropdown");

      if (!dropdown) {
        return;
      }

      const { y, height } = navItem.getBoundingClientRect();
      const itemTop = y + height;
      const dropdownY = dropdown.getBoundingClientRect().y;
      const isSameOffset = itemTop === dropdownY;

      if (isSameOffset) {
        return;
      }

      const difference = Math.round(dropdownY - itemTop);

      navItem.style.setProperty("--after-height", `${difference}px`);
    });
  });
});

// Add is scrolled class for header when transparent and sticky are enabled

let hero =
  document.querySelector(".hero-banner") ||
  document.querySelector("main section");

window.addEventListener("shopify:section:load", function () {
  hero =
    document.querySelector(".hero-banner") ||
    document.querySelector("main section");
});

const megaMenu = document.querySelector('nav.js-nav');
if (megaMenu) {
  // CHANGE: function name is not relevant to what it does
  function toggleHeaderTransparency() {
    const hasVisibleDropdown = megaMenu.querySelector('.js-dropdown.is-visible');

    if (hasVisibleDropdown) {
      header.classList.add('is-megamenu-open');
    } else {
      header.classList.remove('is-megamenu-open');
    }
  }

  megaMenu.querySelectorAll('.js-nav-item').forEach(item => {
    const menuContent = item.querySelector('.js-dropdown');

    item.addEventListener('mouseenter', () => {
      const menuItem = item.getAttribute('data-menu-item');
      if (menuItem === null) {
        return; // if menu item is not defined, return
      }
      closeAllDropdowns();
      if (menuContent) {
        menuContent.classList.add('is-visible');
      }
      toggleHeaderTransparency(); // update header transparency
    });

    item.addEventListener('mouseleave', e => {
      const related = e.relatedTarget;
      if (related && (menuContent?.contains(related) || item.contains(related) || megaMenu.contains(related))) {
        return; // if mouse is still in the menu, keep the dropdown open
      }
      closeAllDropdowns();
      toggleHeaderTransparency(); // update header transparency
    });

    if (menuContent) {
      menuContent.addEventListener('mouseleave', e => {
        const related = e.relatedTarget;
        if (related && (menuContent.contains(related) || item.contains(related) || megaMenu.contains(related))) {
          return; // if mouse is still in the menu, keep the dropdown open
        }
        closeAllDropdowns();
        toggleHeaderTransparency(); // update header transparency
      });
    }
  });
  megaMenu.addEventListener('mouseleave', () => {
    closeAllDropdowns();
    toggleHeaderTransparency(); // update header transparency
  });

  function closeAllDropdowns() {
    megaMenu.querySelectorAll('.js-dropdown.is-visible').forEach(dropdown => {
      const item = dropdown.closest('.js-nav-item');
      const menuItem = item?.getAttribute('data-menu-item');

      if (menuItem === null) {
        return; // if menu item is not defined, return
      }
      dropdown.classList.remove('is-visible');
    });
  }
}

document.querySelectorAll('.header__nav-item.dropdown [data-child-menu-item]').forEach(childItem => {
  const childMenuContent = childItem.querySelector('[data-child-menu-content]');

  childItem.addEventListener('mouseenter', () => {
    document.querySelectorAll('.header__nav-item.dropdown [data-child-menu-content]').forEach(menuContent => {
      menuContent.classList.remove('is-visible');
    });
    childMenuContent?.classList.add('is-visible');
  });

  childItem.addEventListener('mouseleave', e => {
    const related = e.relatedTarget;
    // if mouse enters another sibling `data-child-menu-item`, remove 'is-visible'
    if (
      related &&
      related.closest('[data-child-menu-item]') !== childItem &&
      related.closest('[data-child-menu-item]')
    ) {
      childMenuContent?.classList.remove('is-visible');
    }
  });
});
// Animations

const animationObserverOptions = {
  rootMargin: "-100px"
};

const animationObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      return;
    }

    entry.target.classList.add("animation-init");
    entry.target.addEventListener(
      "animationend",
      () => {
        entry.target.classList.add("animation-none");
      },
      {
        once: true
      }
    );
    animationObserver.unobserve(entry.target);
  });
}, animationObserverOptions);

observeAnimationElements();

window.addEventListener("shopify:section:load", () => {
  observeAnimationElements();
});

function observeAnimationElements() {
  const animationElements = document.querySelectorAll(
    '[class*="js-animation-"]'
  );

  animationElements.forEach(animationElement => {
    animationObserver.observe(animationElement);
  });
}

function preventDefault(event) {
  event.preventDefault();
}

// DropdownInput

class DropdownInput extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");
    this.dropdown = null;
    this.buttons = null;
    this.detailsTemplate = this.querySelector(
      'template[data-name="details"]'
    );
    this.optionTemplate = this.querySelector(
      'template[data-name="option"]'
    );
    if (!this.select) return;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.select.classList.add("hidden");
    this.appendTemplate();
  }

  appendTemplate() {
    const detailsTemplate =
      this.detailsTemplate.content.firstElementChild.cloneNode(true);
    const optionTemplate = this.optionTemplate.content;
    const options = Array.from(this.select.options);
    if (options.length === 0) return;
    const selectedOption = options.find(option => option.selected);
    detailsTemplate.querySelector("[data-label]").textContent =
      selectedOption.label;

    options.forEach(option => {
      const html = optionTemplate.cloneNode(true);
      const button = html.querySelector("button");
      const li = html.querySelector("li");

      button.setAttribute("data-value", option.value);
      button.textContent = option.label;
      button.toggleAttribute("disabled", option.disabled);
      li.classList.toggle("is-active", option.selected);
      detailsTemplate.querySelector("[data-options]").append(html);
    });

    this.append(detailsTemplate);
    this.dropdown = this.querySelector("details");
    this.buttons = this.dropdown.querySelectorAll("button");
    this.setHandlers();
  }

  update() {
    this.dropdown = null;
    this.buttons = null;
    this.querySelector("details")?.remove();
    this.appendTemplate();
  }

  setHandlers() {
    this.querySelector("summary").addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.buttons.forEach((button, index) => {
      button.addEventListener("click", event =>
        this.onOptionSelect(event, index)
      );
    });
  }

  onOptionSelect(event, index) {
    event.preventDefault();
    Array.from(this.select.options).forEach(option =>
      option.removeAttribute("selected")
    );

    this.select.options[index].setAttribute("selected", "selected");
    this.select.value = event.target.dataset.value;
    this.select.dispatchEvent(new Event("change", { bubbles: true }));
    this.querySelector("[data-label]").textContent =
      this.select.options[index].label;
    this.setSelectedOption(event.target);

    // when option is selected, update the dropdown
    this.update();
  }

  setSelectedOption(buttonOption) {
    const buttonEl = buttonOption;
    this.buttons.forEach(button => {
      button.parentElement.classList.remove("is-active");
    });
    buttonEl.parentElement.classList.add("is-active");
    this.select.dispatchEvent(new Event("change"));
    this.select.closest("form")?.dispatchEvent(new Event("input"));
    this.close(
      undefined,
      this.dropdown.querySelector("summary"),
      this.dropdown
    );
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    isOpen
      ? this.close(event, summaryElement, detailsElement)
      : this.open(summaryElement, detailsElement);
  }

  open(summaryElement, detailsElement) {
    setTimeout(() => {
      detailsElement.classList.add("is-open");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(detailsElement, summaryElement);
  }

  close(event, summaryElement, detailsElement) {
    if (event) {
      event.preventDefault();
    }

    detailsElement.classList.remove("is-open");
    removeTrapFocus(summaryElement);
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      elapsedTime < 300 // Increase for animation duration if necessary
        ? window.requestAnimationFrame(handleAnimation)
        : detailsElement.removeAttribute("open");
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("dropdown-input", DropdownInput);

// Countdown Timer
class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    const timezone = this.dataset.timezone,
      date = this.dataset.date.split("-").filter(function (el) { return el != ""; }),
      day = parseInt(date[0]),
      month = parseInt(date[1]),
      year = parseInt(date[2]);

    let time = this.dataset.time,
      tarhour,
      tarmin;

    if (time != null) {
      time = time.split(":");
      tarhour = parseInt(time[0]);
      tarmin = parseInt(time[1]);
    }

    // Set the date we're counting down to
    let date_string =
      month +
      "/" +
      day +
      "/" +
      year +
      " " +
      tarhour +
      ":" +
      tarmin +
      " GMT" +
      timezone;
    // Time without timezone
    this.countDownDate = new Date(
      year,
      month - 1,
      day,
      tarhour,
      tarmin,
      0,
      0
    ).getTime();

    // Time with timezone
    this.countDownDate = new Date(date_string).getTime();
  }

  convertDateForIos(date) {
    var arr = date.split(/[- :]/);
    date = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    );
    return date;
  }
  connectedCallback() {
    let _this = this;
    let timer_layout = _this.dataset.timerLayout;
    let timer_ended_message = _this.dataset.endMessage;

    const updateTime = function () {
      // Get todays date and time
      const now = new Date().getTime();

      // Find the distance between now an the count down date
      const distance = _this.countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let countdownTimerColumns = _this.querySelector(
        ".countdown-timer__columns"
      );
      let countdownTimerMessage = _this.querySelector(
        ".countdown-timer__message"
      );

      // set .countdown-timer__column-number blocks
      let daysBlock = _this.querySelector(
        ".days .countdown-timer__column-number"
      );
      let hoursBlock = _this.querySelector(
        ".hours .countdown-timer__column-number"
      );
      let minutesBlock = _this.querySelector(
        ".minutes .countdown-timer__column-number"
      );
      let secondsBlock = _this.querySelector(
        ".seconds .countdown-timer__column-number"
      );

      if (distance < 0) {
        if (daysBlock) daysBlock.innerHTML = 0;
        if (hoursBlock) hoursBlock.innerHTML = 0;
        if (minutesBlock) minutesBlock.innerHTML = 0;
        if (secondsBlock) secondsBlock.innerHTML = 0;

        _this.classList.add("loading-effect");

        // update data-is-ended attribute
        _this.setAttribute("data-is-ended", "true");

        // if data-timer-layout is not '1', hide the countdown
        if (timer_layout !== "1") {
          // if the countdown is over, show the message and hide the countdown
          if (countdownTimerColumns)
            countdownTimerColumns.classList.add("hidden");
          if (countdownTimerMessage)
            countdownTimerMessage.classList.remove("hidden");
        }

        if (timer_layout === "1") {
          // change nearest .callout-banner__content-heading text with timer is ended message
          let calloutBannerContentHeading = _this
            .closest(".callout-banner")?.querySelector(".callout-banner__content-heading");
          if (calloutBannerContentHeading)
            calloutBannerContentHeading.innerHTML =
              _this.dataset.endMessage;
        }
      } else {
        requestAnimationFrame(updateTime);

        if (daysBlock)
          daysBlock.innerHTML = CountdownTimer.addZero(days);
        if (hoursBlock)
          hoursBlock.innerHTML = CountdownTimer.addZero(hours);
        if (minutesBlock)
          minutesBlock.innerHTML = CountdownTimer.addZero(minutes);
        if (secondsBlock)
          secondsBlock.innerHTML = CountdownTimer.addZero(seconds);

        // if days is 0, remove the days block
        if (days === 0) {
          if (daysBlock)
            daysBlock.parentElement.parentElement.remove();
        }

        _this.classList.remove("loading-effect");
      }
    };
    requestAnimationFrame(updateTime);
  }
  static addZero(x) {
    return x < 10 && x >= 0 ? "0" + x : x;
  }
}
customElements.define("countdown-timer", CountdownTimer);

if (!customElements.get("text-truncator")) {
  class TextTruncator extends HTMLElement {
    constructor() {
      super();
      this.initElements();
    }

    connectedCallback() {
      this.setupTextTruncation();
      // Uncomment the following line to enable resizing functionality
      // window.addEventListener('resize', this.setupTextTruncation.bind(this));
    }

    initElements() {
      this.textTruncatorButton = this.querySelector(".text-truncator__button");
      this.textTruncatorButtonText = this.textTruncatorButton?.querySelector(".text-truncator__button-text");
      this.textTruncatorIconPlus = this.textTruncatorButton?.querySelector(".icon-plus");
      this.textTruncatorIconMinus = this.textTruncatorButton?.querySelector(".icon-minus");
    }

    setupTextTruncation() {
      const textTruncator = this.querySelector(".text-truncator");
      textTruncator.style.display = "block"; // show the block initially

      const { lineHeight, lineCount, maxLineCount } = this.calculateLineCounts(textTruncator);

      if (lineCount > maxLineCount) {
        this.applyTextTruncation(textTruncator, lineHeight, maxLineCount);
        this.setupButton(textTruncator);
      } else {
        this.removeTextTruncation(textTruncator);
      }
    }

    calculateLineCounts(element) {
      const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
      const lineCount = Math.floor(element.clientHeight / lineHeight);
      const maxLineCount = parseInt(this.dataset.maxLineCount);

      return { lineHeight, lineCount, maxLineCount };
    }

    applyTextTruncation(element, lineHeight, maxLineCount) {
      element.classList.add("text-truncator--hidden");

      const maxHeight = `${lineHeight * maxLineCount}px`;
      const style = document.createElement("style");
      style.innerHTML = `.text-truncator--hidden { max-height: ${maxHeight}; }`;
      document.head.appendChild(style);
      if (this.textTruncatorButton) {
        this.textTruncatorButton.style.display = "";
      }
    }

    removeTextTruncation(element) {
      element.classList.remove("text-truncator--hidden");

      if (this.textTruncatorButton) {
        this.textTruncatorButton.style.display = "none";
      }
    }

    setupButton(textTruncator) {
      if (this.textTruncatorButton) {
        this.textTruncatorButtonText.innerHTML = `<span>${this.dataset.readMore}</span>`;
        this.toggleIcons("plus");
        this.textTruncatorButton.addEventListener("click", (event) => {
          event.preventDefault();
          this.toggleTextTruncation(textTruncator);
        });
      }
    }

    toggleTextTruncation(textTruncator) {
      const paragraphs = textTruncator.querySelectorAll("p");
      const isHidden = textTruncator.classList.contains("text-truncator--hidden");

      paragraphs.forEach((paragraph, index) => {
        paragraph.style.marginTop = isHidden && index !== 0 ? "1rem" : "";
      });

      textTruncator.classList.toggle("text-truncator--hidden");
      this.textTruncatorButtonText.innerHTML = `<span>${isHidden ? this.dataset.readLess : this.dataset.readMore}</span>`;
      this.toggleIcons(isHidden ? "minus" : "plus");

      // on mobile, if the text is expanded, set max-height to 4rem
      if (isHidden && window.innerWidth < 768) {
        textTruncator.style.overflow = "scroll";
      } else {
        textTruncator.style.maxHeight = "";
        textTruncator.style.overflow = "";
      }
    }

    toggleIcons(iconType) {
      this.textTruncatorIconPlus.style.display = iconType === "plus" ? "inline-block" : "none";
      this.textTruncatorIconMinus.style.display = iconType === "minus" ? "inline-block" : "none";
    }
  }
  customElements.define("text-truncator", TextTruncator);
}

if (!customElements.get("custom-countdown-timer")) {
  class CustomCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.duration = this.parseTimeToSeconds(this.dataset.duration) || 900; // default 15 min
      this.remaining = this.duration;
      this.timer = null;
      console.log('CustomCountdownTimer created:', this);
    }

    parseTimeToSeconds(timeString) {
      if (!timeString) return null;
      
      // If it's already a number (seconds), return it
      if (!isNaN(timeString) && !timeString.includes(':')) {
        return parseInt(timeString);
      }
      
      // Parse time format: supports DD:HH:MM:SS, HH:MM:SS, MM:SS
      const parts = timeString.split(':').map(part => parseInt(part) || 0);
      
      if (parts.length === 2) {
        // MM:SS format
        const [minutes, seconds] = parts;
        return (minutes * 60) + seconds;
      } else if (parts.length === 3) {
        // HH:MM:SS format
        const [hours, minutes, seconds] = parts;
        return (hours * 3600) + (minutes * 60) + seconds;
      } else if (parts.length === 4) {
        // DD:HH:MM:SS format
        const [days, hours, minutes, seconds] = parts;
        return (days * 86400) + (hours * 3600) + (minutes * 60) + seconds;
      }
      
      return null;
    }

    connectedCallback() {
      console.log('CustomCountdownTimer connected, starting countdown');
      this.startCountdown();
    }

    startCountdown() {
      this.timer = setInterval(() => {
        // Calculate days, hours, minutes and seconds
        const days = Math.floor(this.remaining / 86400);
        const hours = Math.floor((this.remaining % 86400) / 3600);
        const minutes = Math.floor((this.remaining % 3600) / 60);
        const seconds = this.remaining % 60;

        // Format with leading zeros
        const formatTime = (time) => time < 10 ? "0" + time : time;

        // Update individual elements if they exist (for structured display)
        const daysElement = this.querySelector('.days-part .countdown-number');
        const hoursElement = this.querySelector('.hours-part .countdown-number');
        const minutesElement = this.querySelector('.minutes-part .countdown-number');
        const secondsElement = this.querySelector('.seconds-part .countdown-number');

        if (daysElement) daysElement.textContent = formatTime(days);
        if (hoursElement) hoursElement.textContent = formatTime(hours);
        if (minutesElement) minutesElement.textContent = formatTime(minutes);
        if (secondsElement) secondsElement.textContent = formatTime(seconds);

        // Also update main textContent for backward compatibility
        // Build display string based on what units are needed
        let displayParts = [];
        
        if (days > 0) {
          displayParts.push(`${formatTime(days)}:${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`);
        } else if (hours > 0) {
          displayParts.push(`${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`);
        } else {
          displayParts.push(`${formatTime(minutes)}:${formatTime(seconds)}`);
        }

        // Only set textContent if no structured elements exist
        if (!daysElement && !hoursElement && !minutesElement && !secondsElement) {
          this.textContent = displayParts[0];
        }

        if (--this.remaining < 0) {
          this.remaining = this.duration; // reset when finished
        }
      }, 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }
  customElements.define("custom-countdown-timer", CustomCountdownTimer);
}

class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.vertical_offset_for_trigger = window.innerHeight * 0.5;
    this.addEventListener("click", this.scrollToTop.bind(this));
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      behavior: "smooth"
    });
  }

  connectedCallback() {
    window.addEventListener("scroll", () => this.handleScroll(), {
      passive: true
    });
  }

  handleScroll() {
    const top = window.pageYOffset;
    if (top > this.vertical_offset_for_trigger) {
      this.classList.remove("hide");
    } else {
      this.classList.add("hide");
    }
  }
}

customElements.define("back-to-top", BackToTop);

const submenuButtons = document.querySelectorAll(
  ".drawer__submenu-btn"
);

submenuButtons.forEach(button => {
  button.addEventListener("click", function () {
    const parentDiv = button.parentElement;
    const isActive = parentDiv.classList.contains("is-active");

    // Etkin öğeyi doğrula
    const submenuSecond = parentDiv.querySelector(
      ".drawer__submenu-second"
    );
    if (submenuSecond) {
      submenuSecond.style.height = isActive ? "0px" : "auto";
    }

    const submenuItems = document.querySelectorAll(
      ".drawer__submenu-first-item"
    );
    submenuItems.forEach(item => {
      item.classList.remove("is-active");
      const submenu = item.querySelector(".drawer__submenu-second");
      if (submenu) {
        submenu.style.height = "0px";
      }
    });

    if (!isActive) {
      parentDiv.classList.add("is-active");
      const submenuSec = parentDiv.querySelector(
        ".drawer__submenu-second"
      );
      if (submenuSec) {
        submenuSec.style.height = "auto";
      }
    }
  });
});

// /* constants */
// const PUB_SUB_EVENTS = {
//   cartUpdate: "cart-update",
//   quantityUpdate: "quantity-update",
//   variantChange: "variant-change",
//   cartError: "cart-error"
// };

document.addEventListener("DOMContentLoaded", function () {
  var menuLinks = document.querySelectorAll("button.menu-link, button.menu-link-toggle");

  // Handle menu link click
  menuLinks.forEach(function (menuLink) {
    menuLink.addEventListener("click", function(event) {
      event.stopPropagation();
      
      var activeMenuLink = document.querySelector(".menu-panel.is-active");
      var isNested = activeMenuLink?.hasAttribute("data-menu-nested");
      var targetRef = menuLink.dataset.ref;
      var targetPanel = document.querySelector(
        'div.menu-panel[data-menu="' + targetRef + '"]'
      );
      var targetDropdown = document.querySelector(
        '[data-dropdown="' + targetRef + '"]'
      );

      var allDropdowns = document.querySelectorAll('[data-dropdown]');

      if (targetDropdown) {
        allDropdowns.forEach(function (dropdown) {
          if (dropdown !== targetDropdown && dropdown !== targetDropdown.parentElement) {
            dropdown.classList.remove("active");
            dropdown.style.height = '0';
            var refElement = document.querySelector('[data-ref="' + dropdown.dataset.dropdown + '"]');
            if (refElement) {
              // Handle both old button.menu-link and new button.menu-link-toggle
              if (refElement.classList.contains('menu-link-toggle')) {
                refElement.closest('.menu-link-wrapper')?.classList.remove("is-active");
              } else {
                refElement.classList.remove("is-active");
              }
            }
          }else if(dropdown === targetDropdown.parentElement){
            targetDropdown.parentElement.style.setProperty('height', 'auto', 'important');
          }
        });
        const naturalHeight = targetDropdown.scrollHeight + 'px';
        targetDropdown.style.height = '0';
        targetDropdown.offsetHeight;
        
        if (targetDropdown.classList.contains("active")) {
          targetDropdown.style.height = '0';
        }else {
          targetDropdown.style.setProperty('height', naturalHeight, 'important');
        }
        targetDropdown.classList.toggle("active");
        
        // Handle both old button.menu-link and new button.menu-link-toggle
        if (menuLink.classList.contains('menu-link-toggle')) {
          menuLink.closest('.menu-link-wrapper')?.classList.toggle("is-active");
        } else {
          menuLink.classList.toggle("is-active");
        }
      }

      var allPanels = document.querySelectorAll(".menu-panel");

      if (targetPanel) {
        allPanels.forEach(function (panel) {
          if (panel.classList.contains("is-active")) {
            panel.classList.remove("is-active");
            panel.classList.add("was-active");
          }
        });

        // Add "is-active" class to the target menu panel
        targetPanel.classList.add("is-active");
        if (isNested) {
          targetPanel.classList.add("is-instant");
        }

        setTimeout(() => {
          allPanels.forEach(function (panel) {
            panel.classList.remove("was-active");
            targetPanel.classList.remove("is-instant");
          });
        }, 100);
      } else {
        allPanels.forEach(function (panel) {
          panel.classList.remove("is-active");
        });
      }
    });
  });

  var faqPage = document.querySelector('.template--faq');

  if(faqPage) {
    var accordions = document.querySelectorAll(".accordion__section");
    accordions.forEach(function (accordion) {
      accordion.addEventListener("click", function () {
        var headerHeight = document.querySelector(".header").offsetHeight;
        var bodyHeight = this.offsetHeight;
        var accordionTop = accordion.getBoundingClientRect().top;
        var scrollTo = accordionTop - headerHeight - bodyHeight;

        if (scrollTo < 0) {
          scrollTo = 0;
        }
        if (accordionTop > headerHeight) {
          scrollTo = window.scrollY;
        }

        window.scrollTo({
          top: scrollTo,
          behavior: "smooth"
        });
      });
    });
  }
});

/* swiper - hide swiper buttons element if both next and prev buttons are disabled */
document.addEventListener("DOMContentLoaded", function () {
  const allSwiperButtons = document.querySelectorAll(".swiper-buttons");
  allSwiperButtons.forEach(function (swiperButtons) {
    const prevButton = swiperButtons.querySelector("[class^='swiper-button--prev'], [class*=' swiper-button--prev']");
    const nextButton = swiperButtons.querySelector("[class^='swiper-button--next'], [class*=' swiper-button--next']");
    if (prevButton && nextButton && prevButton.classList.contains("swiper-button-disabled") && nextButton.classList.contains("swiper-button-disabled")) {
      swiperButtons.style.display = "none";
    }

    // get grand parent child of swiper-buttons
    const grandParent = swiperButtons.parentElement.parentElement;
    // if grand parent has class of section__foot and this section__foot has no a.button set margin-block-start to 0
    if (grandParent.classList.contains("section__foot") && !grandParent.querySelector("a.button")) {
      grandParent.style.marginBlockStart = "0";
    }
  });
});

if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.isQuickCart = this.classList.contains(
        "product-card--quick-cart"
      );
      this.init();
    }

    init() {
      this.initForm();
      this.initVariants();
      this.imageBorderCalc();
      if (
        this.querySelector(".product-card__media") &&
        this.querySelector(".product-card__media").classList.contains(
          "product-card__media--hoverable"
        )
      ) {
        this.secondImgHoverStates();
      }

      // if quick-cart-drawer does not exists, remove trigger buttons
      if (!document.querySelector("quick-cart-drawer")) {
        this.querySelector(".quick-cart-drawer__trigger")?.remove();
      }
    }

    /**
     * Add to Cart Form
     */
    initForm() {
      /** Variables */
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      this.addToCartForm = this.querySelector(
        "form.product-card__add-to-cart--form"
      );
      if (this.addToCartForm) {
        this.addToCartForm.removeAttribute("method");
        this.addToCartForm.removeAttribute("action");
      }
      this.submitButton = this.querySelector('button[type="submit"]');
      /** Event Listeners */
      if (this.addToCartForm) {
        this.addToCartForm.addEventListener(
          "submit",
          this.submitAddToCartForm.bind(this)
        );
      }
    }

    submitAddToCartForm(event) {
      event.preventDefault();

      this.submitButton.setAttribute("disabled", "");
      this.submitButton.classList.add("add-to-cart--is-disabled");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(event.target);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart
            .getSectionsToRender()
            .map(section => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.errors) {
            this.handleErrorMessage(response.errors);
            return;
          }

          if (this.cart) {
            this.cart.renderContents(response);
          }

          updateCartCounters();
        })
        .catch((error) => { console.error(error) })
        .finally(() => {
          this.submitButton.removeAttribute("disabled");
          this.submitButton.classList.remove(
            "add-to-cart--is-disabled"
          );
          if(this.parentElement.className.includes('upsell-grid')) {
            this.closest('modal-dialog.product-upsell-popup')?.hide();
          }
          const quickCartDrawer = this.closest("quick-cart-drawer");
          if (quickCartDrawer) {
            quickCartDrawer.close();
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.querySelector(
        ".product-form__error-message-wrapper"
      );
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessageWrapper.querySelector(
        ".product-form__error-message"
      );

      this.errorMessageWrapper.toggleAttribute(
        "hidden",
        !errorMessage
      );

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }

      setTimeout(() => {
        this.resetErrorMessage();
      }, 5000);
    }

    resetErrorMessage() {
      if (!this.errorMessageWrapper) return;
      this.errorMessageWrapper.toggleAttribute("hidden", true);
      this.errorMessageWrapper.textContent = "";
    }

    /**
     * Product Variants
     */
    initVariants() {
      this.getVariantsData();

      // event listeners for variant buttons
      this.querySelectorAll(".button--variant input").forEach(
        variantButton => {
          variantButton.addEventListener(
            "click",
            this.onClickOptionRadioInputs.bind(this)
          );
        }
      );

      // set initial checked options
      let initialCheckedOptions = [];
      this.querySelectorAll(".variant-option-radio-input").forEach(
        radioInput => {
          if (radioInput.checked) {
            initialCheckedOptions.push(radioInput.value);
          }
        }
      );

      // ensure at least one option is selected on load
      if (initialCheckedOptions.length === 0) {
        this.querySelector(".variant-option-radio-input")?.click();
      }

      // immediately update variant statuses to set disabled states on load
      this.updateVariantStatuses();

      const { currentVariantId } = this.findCurrentVariantFromOptionRadioInputs();

      // update media and cart button states
      if (!this.querySelector(".product-card__media")?.dataset.updateMedia) {
        this.updateMediaForVariant(currentVariantId);
      }
      this.setCartButtonState();
    }

    updateVariantStatuses() {

      const selectedOptionOneVariants = this.variantsObj?.filter(
        variant =>
          this.querySelector(":checked")?.value === variant.option1
      );

      const inputWrappers = [
        ...this.querySelectorAll(".js-product-card-options")
      ];

      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [
          ...option.querySelectorAll('input[type="radio"]')
        ];
        const previousOptionSelected =
          inputWrappers[index - 1].querySelector(":checked")?.value;
        const availableOptionInputsValue = selectedOptionOneVariants
          ?.filter(
            variant =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map(variantOption => variantOption[`option${index + 1}`]);

        this.setInputAvailability(
          optionInputs,
          availableOptionInputsValue
        );
      });
    }

    setInputAvailability(elementList, availableValuesList) {
      elementList.forEach(element => {
        const value = element.getAttribute("value");
        const availableElement = availableValuesList.includes(value);
        element
          .closest("li")
          .classList.toggle("disabled", !availableElement);
        element.toggleAttribute("disabled", !availableElement);
      });
    }

    onClickOptionRadioInputs(event) {
      const {
        currentVariantId,
        currentCheckedOptions,
        currentVariantMediaId
      } = this.findCurrentVariantFromOptionRadioInputs();

      this.clearRadioInputStates(event);

      if (currentCheckedOptions.includes(event.target.value)) {
        // console.log('event.target', event.target);
        event.target.setAttribute("checked", "");
        // event.target.closest("div").classList.add("checked");

        this.updateVariantStatuses();

        this.disableAddToCartButons();

        // call to update price when variant is changed
        this.updatePriceForVariant(currentVariantId);

        // call to update discount badge when variant is changed
        this.updateDiscountBadgeForVariant(currentVariantId);
      }

      // update form input variant-id
      this.updateFormVariantIdInput();

      // update product image shown
      let allVariantIdsWithImageAvailable = [];
      this.querySelectorAll("[data-product-images]").forEach(el => {
        el.getAttribute("data-product-images")
          .split(",")
          .forEach(v => {
            allVariantIdsWithImageAvailable.push(v);
          });
      });
      if (allVariantIdsWithImageAvailable.includes(currentVariantId.toString())) {
        this.updateMediaForVariant(currentVariantId);
      }

      if (this.isQuickCart && currentVariantMediaId) {
        document
          .querySelector("quick-cart-drawer")
          .setActiveMedia(currentVariantMediaId);
      }

      // update product link
      this.querySelectorAll("[data-product-link]").forEach(
        linkItem => {
          const currentLink = linkItem.getAttribute("href");
          if (currentVariantId) {
            const newLink =
              currentLink.split("?variant=")[0] +
              "?variant=" +
              currentVariantId;
            linkItem.setAttribute("href", newLink);
          }
        }
      );
    }

    setCartButtonState() {
      const { currentVariantAvailable } = this.findCurrentVariantFromOptionRadioInputs();
      if (!currentVariantAvailable) return;
      this.submitButton?.toggleAttribute(
        "disabled",
        !currentVariantAvailable
      );
    }

    updateMediaForVariant(currentVariantId) {
      if (!currentVariantId) return;
      this.querySelectorAll("[data-product-images]").forEach(el => {
        el.classList.toggle(
          "hidden",
          !el
            .getAttribute("data-product-images")
            .includes(currentVariantId)
        );
      });
    }

    updateFormVariantIdInput() {
      const { currentVariantId } = this.findCurrentVariantFromOptionRadioInputs();
      const input = this.querySelector('input[name="id"]');
      if (currentVariantId && input) {
        this.querySelector('input[name="id"]').value = currentVariantId;
      }
    }

    updatePriceForVariant(variantId) {
      // Assuming the variantsObj contains the variant data, including price
      const selectedVariant = this.variantsObj?.find(
        variant => variant.id === variantId
      );

      if (selectedVariant) {
        let priceContainer = this.querySelector(".price__container");
        // if priceContainer does not exist, check previous element
        if (!priceContainer) {
          const previousElement = this.previousElementSibling;
          if (previousElement) {
            // check if previous element has class of price__container
            priceContainer = previousElement.querySelector(
              ".price__container"
            );
          }
        }

        if (!priceContainer) return;
        const moneyFormat = priceContainer.dataset.moneyFormat;
        const price = formatPrice(
          moneyFormat,
          selectedVariant.price / 100
        );
        const compare_at_price = formatPrice(
          moneyFormat,
          selectedVariant.compare_at_price / 100
        );
        const labelPriceRegular =
          priceContainer.dataset.labelPriceRegular;
        const labelPriceSale = priceContainer.dataset.labelPriceSale;

        if (compare_at_price > price) {
          // generate html block and append to price container
          const priceHtml = `
            <div class="price__sale">
              <div class="price__sale-inner">
                <span class="visually-hidden">${labelPriceSale}</span>
                <s>${compare_at_price}</s>
                <ins>
                  <span class="visually-hidden">${labelPriceRegular}</span>
                  ${price}
                </ins>
              </div>
            </div>
          `;
          priceContainer.innerHTML = priceHtml;
        } else {
          // generate html block and append to price container
          const priceHtml = `
            <div class="price__sale">
              <div class="price__sale-inner">
                <span class="visually-hidden">${labelPriceRegular}</span>
                ${price}
              </div>
            </div>
          `;
          priceContainer.innerHTML = priceHtml;
        }
      }
    }

    updateDiscountBadgeForVariant(variantId) {
      const selectedVariant = this.variantsObj?.find(
        variant => variant.id === variantId
      );
      if (selectedVariant) {
        let discountBadge = this.querySelector(
          ".product-card__badge--discount"
        );
        // if discountBadge does not exist, check previous element
        if (!discountBadge) {
          const previousElement = this.previousElementSibling;
          if (previousElement) {
            // check if previous element has class of product-card__badge--discount
            discountBadge = previousElement.querySelector(
              ".product-card__badge--discount"
            );
          }
        }

        if (discountBadge) {
          if (
            selectedVariant.compare_at_price > selectedVariant.price
          ) {
            discountBadge.classList.remove("hidden");
            const percentageElement =
              discountBadge.querySelector(".percentage");
            // calculate discount percentage
            const discountPercentage = Math.round(
              ((selectedVariant.compare_at_price -
                selectedVariant.price) /
                selectedVariant.compare_at_price) *
                100
            );
            // update discount percentage
            percentageElement.textContent = discountPercentage;
          } else {
            discountBadge.classList.add("hidden");
          }
        }
      }
    }

    disableCheckedVariantOptions() {
      this.querySelectorAll(
        ".variant-option-radio-input[checked]"
      ).forEach(variantBtn => {
        if (this.isQuickCart) {
          variantBtn.setAttribute("disabled", "");
          // variantBtn.closest("div").classList.add("disabled");
        } else {
          variantBtn.removeAttribute("disabled");
        }
      });
    }

    disableAddToCartButons() {
      const { currentVariantAvailable } =
        this.findCurrentVariantFromOptionRadioInputs();
      const submitBtn = this.querySelector(
        ".product-card__add-to-cart--form button[type='submit']"
      );

      if (
        submitBtn &&
        !submitBtn.classList.contains(
          "product-card__add-to-cart--button"
        )
      ) {
        if (!currentVariantAvailable) {
          submitBtn.setAttribute("disabled", "");
        } else {
          submitBtn.removeAttribute("disabled");
        }
      }
    }

    clearRadioInputStates(event) {
      event.target
        .closest(".js-product-card-options")
        .querySelectorAll(".variant-option-radio-input")
        .forEach(radioInput => {
          radioInput.removeAttribute("checked");
          // radioInput.closest("div").classList.remove("checked");
        });
    }

    findCurrentVariantFromOptionRadioInputs() {
      let currentVariantAvailable = null;
      let currentVariantId = "";
      let currentVariantMediaId = "";
      let currentCheckedOptions = [];

      this.querySelectorAll(".js-product-card-options").forEach(
        item => {
          if (!item.parentNode.classList.contains("hidden")) {
            item
              .querySelectorAll('input[type="radio"]')
              .forEach(radioInput => {
                if (radioInput.checked) {
                  currentCheckedOptions.push(radioInput.value);
                }
              });
          } else {
            // hidden variant (size or etc) always uses the first option
            currentCheckedOptions.push(
              item.querySelector('input[type="radio"]').value
            );
          }
        }
      );

      this.variantsObj?.forEach(item => {
        if (
          item.options.join() === currentCheckedOptions.join() ||
          (item.options.length === 1 &&
            currentCheckedOptions.length === 0)
        ) {
          currentVariantId = item.id;
          currentVariantAvailable = item.available;
          currentVariantMediaId = item.featured_media?.id || null;
        }
      });

      return {
        currentVariantAvailable,
        currentVariantId,
        currentCheckedOptions,
        currentVariantMediaId
      };
    }

    findAndDisableAllUnavailableOptionsForSelectedVariant(
      selectedOption
    ) {
      let selectedOptionName = "";
      if (selectedOption) {
        selectedOptionName = selectedOption.value;
      } else {
        selectedOptionName = this.querySelectorAll(
          ".variant-option-radio-input"
        )[0].value;
      }

      const { currentCheckedOptions } =
        this.findCurrentVariantFromOptionRadioInputs();
      const optionIndex =
        currentCheckedOptions.indexOf(selectedOptionName) + 1;

      this.variantsObj.forEach(item => {
        if (
          item[`option${optionIndex}`] === selectedOptionName &&
          !item.available
        ) {
          [1, 2, 3].forEach(i => {
            if (i !== optionIndex && item[`option${i}`]) {
              const itemToDisable = this.querySelector(
                `.variant-option-radio-input[value="${
                  item[`option${i}`]
                }"]`
              );
              // itemToDisable.setAttribute("disabled", "");
              itemToDisable.closest("li").classList.add("disabled");
            }
          });
        }
      });
    }

    getVariantsData() {
      const variantsObj = JSON.parse(
        this.querySelector("[data-product-variants-json]")
          ? this.querySelector("[data-product-variants-json]")
              .textContent
          : "[]"
      );
      if (variantsObj && Object.keys(variantsObj).length === 0)
        return false;
      this.variantsObj = variantsObj;
      return variantsObj;
    }

    /** Additional event listerner for styling on hovering mutliple nested items */
    secondImgHoverStates() {
      const hoverableItem = this.querySelector(
        ".product-card__actions"
      );

      if (!hoverableItem || window.innerWidth < 750) {
        return;
      }

      hoverableItem.addEventListener("mouseenter", () =>
        hoverableItem.classList.add("is--hovering")
      );
      hoverableItem.addEventListener("mouseleave", () =>
        hoverableItem.classList.remove("is--hovering")
      );
    }

    imageBorderCalc() {
      const images = document.querySelectorAll(".product-swatch__inner-border--enable img");

      if(images) {
        images.forEach((image) => {
          if (image.complete) {
            processImage(image);
          } else {
            image.onload = () => processImage(image);
          }
        });
      }

      function processImage(image) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const width = image.naturalWidth || image.width;
        const height = image.naturalHeight || image.height;

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(image, 0, 0, width, height);

        const centerX = Math.floor(width / 2);
        const centerY = Math.floor(height / 2);

        const pixelData = ctx.getImageData(centerX, centerY, 1, 1).data;
        const r = pixelData[0];
        const g = pixelData[1];
        const b = pixelData[2];

        const darkenFactor = 0.8;
        const darkenedR = Math.max(0, Math.floor(r * darkenFactor));
        const darkenedG = Math.max(0, Math.floor(g * darkenFactor));
        const darkenedB = Math.max(0, Math.floor(b * darkenFactor));
        const darkenedColor = `rgb(${darkenedR}, ${darkenedG}, ${darkenedB})`;

        image.style.borderColor = darkenedColor;
      }
    }

  }
  customElements.define("product-card", ProductCard);
}

async function updateCartCounters() {
  const headerCartCounters = document.querySelectorAll('.cart-count-badge');
  const drawerCartCounters = document.querySelectorAll('.cart-drawer__title-counter');

  // combine both counters and filter out any null elements
  const cartCounters = [...headerCartCounters, ...drawerCartCounters].filter(counter => counter !== null);

  try {
    const response = await fetch(`${routes.cart_url}.json`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    const state = await response.text();
    const parsedState = JSON.parse(state);

    if (cartCounters.length > 0) {
      // update all cart counters with the current item count
      cartCounters.forEach(counter => {
        counter.textContent = parsedState.item_count;
      });
    }

    // toggle 'hidden' class on header counters based on the item count
    if (headerCartCounters.length > 0) {
      headerCartCounters.forEach(counter => {
        counter.classList.toggle("hidden", parsedState.item_count === 0);
      });
    }
  } catch (error) {
    console.error("Cart counters could not be updated:", error);
  }
}

async function updateFreeShipping() {
  const conversionRate = Shopify.currency.rate;
  const {
    money_format: moneyFormat
  } = window.theme.settings;

  const freeShippingElements = document.querySelectorAll("shipping-bar");

  try {
    const response = await fetch("/cart.js");
    let { total_price, item_count, items } = await response.json();
    const visibility = item_count == 0 ? "none" : "block";
    freeShippingElements.forEach(
      el => (el.style.display = visibility)
    );

    // Calculate excluded products' price to subtract from total
    const excludedProductsPrice = items.reduce((sum, item) => {
      if (window.excludedProducts.includes(item.product_id)) {
        return sum + (item.price * item.quantity);
      }
      return sum;
    }, 0);

    total_price = total_price - excludedProductsPrice;

    // Use for loop instead of forEach for proper synchronous execution
    for (let i = 0; i < freeShippingElements.length; i++) {
      const freeShipping = freeShippingElements[i];
      const progressBarInner = freeShipping.querySelector("[data-progress-line]");
      const progressBarBlocks = freeShipping.querySelectorAll(".progress-bar__block-wrapper");
      const progressBarBlockMessages = freeShipping.querySelectorAll(".progress-bar__block-message");
      progressBarBlockMessages.forEach(message => {
        message.classList.add("hidden");
      });

      for (let j = 0; j < progressBarBlocks.length; j++) {
        processBlock(progressBarBlocks[j], items, total_price, conversionRate);
      }

      let activeBlock = freeShipping.querySelector(".progress-bar__block-wrapper.active");

      if (!activeBlock) {
        progressBarInner.style.width = "100%";
        progressBarBlockMessages[progressBarBlockMessages.length - 1]?.classList.remove("hidden");
      } else {
        let threshold = parseInt(activeBlock.dataset.blockThreshold) || 0;
        const index = parseInt(activeBlock.dataset.blockIndex) || 0;
        const totalBlocks = freeShipping.querySelectorAll(".progress-bar__block-wrapper").length;
        const remainingAmountElement = progressBarBlockMessages[index]?.querySelector('.block-remaining-amount');
        if (remainingAmountElement) {
          const remainingCents = threshold - total_price;
          const remainingAmount = remainingCents / 100;
          const fractionDigits = remainingCents % 100 === 0 ? 0 : 2;
          remainingAmountElement.innerHTML = formatPrice(moneyFormat, remainingAmount, fractionDigits);
        }
        progressBarBlockMessages[index]?.classList.remove("hidden");
        
        if(index > 0){
          threshold = threshold - parseInt(progressBarBlocks[index - 1]?.dataset.blockThreshold);
          total_price = total_price - parseInt(progressBarBlocks[index - 1]?.dataset.blockThreshold * conversionRate);
        }

        const singleBlockWidth = 100 / (totalBlocks + 1);
        const progressPercentage = (index * singleBlockWidth) + ((total_price / (threshold * parseInt(conversionRate))) * singleBlockWidth);
        progressBarInner.style.width = `${progressPercentage}%`;
      }
    }
  } catch (error) {
    console.error("Error fetching cart data:", error);
  }
}

async function processBlock(block, items, total_price, conversionRate){
  const blockThreshold = parseFloat(block.dataset.blockThreshold || 0) * conversionRate;
  const prevBlock = block.previousElementSibling;
  const prevThreshold = prevBlock ? parseFloat(prevBlock.dataset.blockThreshold || 0) * conversionRate : 0;

  // Handle completed blocks
  if (total_price >= blockThreshold) {
    block.classList.add('completed');
    block.querySelector('.progress-bar__block-image--after').classList.remove('hidden');
    block.querySelector('.progress-bar__block-image--before').classList.add('hidden');
    block.classList.remove('active');
    const blockProduct = block.dataset.blockProduct;
    const isBlockProductInCart = items.some(item => item.id == blockProduct);
    if(!isBlockProductInCart && blockProduct != undefined){
      let success = await addProductToCart(blockProduct);
    }
  }
  // Handle active block - the one where total_price falls between this and previous threshold
  else if (total_price >= prevThreshold) {
    block.classList.add('active');
    block.querySelector('.progress-bar__block-image--after').classList.add('hidden');
    block.querySelector('.progress-bar__block-image--before').classList.remove('hidden');
    block.classList.remove('completed');
  } 
  // Handle blocks that haven't been reached yet
  else {
    block.querySelector('.progress-bar__block-image--after').classList.add('hidden');
    block.querySelector('.progress-bar__block-image--before').classList.remove('hidden');
    block.classList.remove('active', 'completed');
  }

  await validateBlockProduct(block, items, total_price);
}

async function addProductToCart(blockProduct) {
  const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  
  const formData = new FormData();
  formData.append("items[0][id]", blockProduct);
  formData.append("items[0][quantity]", 1);

  if (cart) {
    formData.append(
      "sections",
      cart
        .getSectionsToRender()
        .map(section => section.section)
    );
    formData.append("sections_url", window.location.pathname);
  }
  
  try {
    const response = await fetch(`/cart/add.js`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });

    if (!response.ok) {
      console.error('Error response from server:', response.status, response.statusText);
      return false;
    }

    const data = await response.json();
    if (!data.items) {
      console.error('Error adding free product:', data);
      return false;
    }
    
    // Update cart count after adding free product
    await updateCartCounters();
    cart.renderContents(data);
    
    return true;
  } catch (error) {
    console.error('Error adding free product to cart:', error);
    return false;
  }
}

async function updateProductQuantity(blockProductInCart, quantity) {
  const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  let formData = new FormData();
  const payload = {
    id: blockProductInCart.key,
    quantity: quantity,
  };
  
  if (cart) {
    payload.sections = cart.getSectionsToRender().map(section => section.section);
    payload.sections_url = window.location.pathname;
  }
  
  formData = JSON.stringify(payload);
  
  // Update headers for JSON data
  const headers = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

  try {
    const response = await fetch(`/cart/change.js`, {
      method: 'POST',
      headers: headers,
      body: formData
    });
    if (!response.ok) {
      console.error('Error response from server:', response.status, response.statusText);
      return false;
    }
    const data = await response.json();
    if (!data.items) {
      console.error('Error updating product quantity:', data);
      return false;
    }
    // Update cart count after updating product quantity
    updateCartCounters();
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "cart-drawer",
      productVariantId: blockProductInCart.id,
      cartData: data
    });
    return true;
  } catch (error) {
    console.error('Error updating product quantity:', error);
    return false;
  }
}

async function validateBlockProduct(block, items, total_price) {
  const blockProduct = block.dataset.blockProduct;
  const blockProductInCart = items.find(item => item.id == blockProduct);

  const threshold = parseFloat(block.dataset.blockThreshold || 0) 
  if(blockProductInCart !== undefined && blockProduct != undefined){

    if(total_price < threshold){
      await updateProductQuantity(blockProductInCart, 0);
    } else if(blockProductInCart.quantity > 1){
      await updateProductQuantity(blockProductInCart, 1);
    }
  }
}

function formatPrice(moneyString, amount, fractionDigits = 2) {
  const numericAmount = Number(amount);
  const formattedAmount = fractionDigits === 0
    ? Math.round(numericAmount).toString()
    : numericAmount.toFixed(fractionDigits);

  const money_format = /{{(.*?)}}/;

  let money_format_option = "";
  if (moneyString.match(money_format)) {
    money_format_option = moneyString.match(money_format)[1];
  } else {
    console.error("No match found");
  }

  let newValue = "";
  switch (money_format_option) {
    case "amount":
      newValue = moneyString.replace(
        money_format,
        Intl.NumberFormat(Shopify.locale, {
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits
        }).format(numericAmount)
      );
      break;
    case "amount_with_comma_separator":
      newValue = moneyString.replace(
        money_format,
        formattedAmount.replace(".", ",")
      );
      break;
    case "amount_no_decimals":
      newValue = moneyString.replace(
        money_format,
        Math.round(amount)
      );
      break;
    case "amount_no_decimals_with_comma_separator":
      newValue = moneyString.replace(
        money_format,
        Intl.NumberFormat(Shopify.locale)
          .format(Math.round(amount))
          .toString()
          .replace(".", ",")
      );
      break;
    default:
      newValue = moneyString.replace(money_format, formattedAmount);
      break;
  }

  return newValue;
}

class SwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.swiperOptions = JSON.parse(this.getAttribute("data-swiper-options")) || {};
    this.swiperInitialized = false; // Prevent multiple initializations

    // this.hiddenClass = "invisible";
    this.section = this.closest("section");
    this.observer = null;
  }

  connectedCallback() {
    if (this.section && this.section.classList.contains("shopify-section")) {
      // this.section.classList.add(this.hiddenClass);

      // Intersection Observer to check visibility
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.init(); // Initialize Swiper when visible
            observer.disconnect(); // Stop observing after initialization
          }
        });
      });

      this.observer.observe(this.section); // Observe the section
    }

    if (Shopify.designMode) {
      window.addEventListener("shopify:section:load", () => this.init());
      window.addEventListener("shopify:section:select", () => this.init());

      // fallback initialization after delay in design mode
      setTimeout(() => {
        if (!this.swiperInitialized) this.init();
      }, 100);
    } else {
      window.addEventListener("load", () => this.init());
    }
  }

  init() {
    if (this.swiperInitialized) return; // prevent multiple initializations
    this.swiperInitialized = true;

    const swiperOptions = this.swiperOptions;
    const resolvedSlidesPerViewMobile =
      swiperOptions.slidesPerView ?? swiperOptions.slidesPerViewMobile;

    const option = {
      slideshowId: swiperOptions.swiperId || "",
      slideCount: swiperOptions.slideCount || 1,
      slidesPerView: resolvedSlidesPerViewMobile ?? "auto",
      slidesPerViewDesktop:
        swiperOptions.slidesPerViewDesktop ||
        swiperOptions.slidesPerView ||
        4,
      slidesPerViewTablet:
        swiperOptions.slidesPerViewTablet ||
        swiperOptions.slidesPerViewDesktop ||
        swiperOptions.slidesPerView ||
        3,
      spaceBetween: swiperOptions.spaceBetweenMobile || 0,
      spaceBetweenDesktop:
        swiperOptions.spaceBetweenDesktop ||
        swiperOptions.spaceBetween ||
        0,
      spaceBetweenTablet:
        swiperOptions.spaceBetweenTablet ||
        swiperOptions.spaceBetweenDesktop ||
        swiperOptions.spaceBetweenMobile ||
        0,
      enabled: swiperOptions.enabled ?? true,
      enabledDesktop:
        swiperOptions.enabledDesktop ?? swiperOptions.enabled ?? true,
      enabledTablet:
        swiperOptions.enabledTablet ??
        swiperOptions.enabledDesktop ??
        swiperOptions.enabled ??
        true,
      autoHeight: swiperOptions.autoHeight || false,
      autoHeightDesktop: swiperOptions.autoHeightDesktop || false,
      autoHeightTablet: swiperOptions.autoHeightTablet || false,
      allowTouchMove:
        swiperOptions.allowTouchMove ??
        (typeof resolvedSlidesPerViewMobile === "number"
          ? swiperOptions.slideCount > resolvedSlidesPerViewMobile
            ? true
            : false
          : true),
      allowTouchMoveTablet:
        swiperOptions.allowTouchMoveTablet ??
        (typeof swiperOptions.slidesPerViewTablet === "number"
          ? swiperOptions.slideCount > swiperOptions.slidesPerViewTablet
            ? true
            : false
          : true),
      allowTouchMoveDesktop:
        swiperOptions.allowTouchMoveDesktop ??
        (typeof swiperOptions.slidesPerViewDesktop === "number"
          ? swiperOptions.slideCount > swiperOptions.slidesPerViewDesktop
            ? true
            : false
          : true),
      centeredSlides: swiperOptions.centeredSlides || false
    };

    let loopEnabled = Boolean(swiperOptions.loop);
    if (loopEnabled && swiperOptions.centeredSlides) {
      const slidesInEl =
        this.querySelectorAll(".swiper-slide").length || option.slideCount;
      if (slidesInEl < 3) {
        loopEnabled = false;
      }
    }

    this.swiperOptions = {
      a11y: false,
      allowTouchMove: option.allowTouchMove,
      loop: loopEnabled,
      rewind: swiperOptions.rewind || false,
      followFinger: swiperOptions.followFinger || false,
      enabled: option.enabled,
      watchOverflow: true,
      observer: true,
      cache: true,
      autoHeight: option.autoHeight,
      centeredSlides: option.centeredSlides,
      slidesPerView: option.slidesPerView,
      spaceBetween: option.spaceBetween,
      breakpoints: {
        750: {
          enabled: option.enabledTablet,
          allowTouchMove: option.allowTouchMoveTablet,
          slidesPerView: option.slidesPerViewTablet,
          spaceBetween: option.spaceBetweenTablet,
          autoHeight: option.autoHeightTablet,
        },
        990: {
          enabled: option.enabledDesktop,
          allowTouchMove: option.allowTouchMoveDesktop,
          slidesPerView: option.slidesPerViewDesktop,
          spaceBetween: option.spaceBetweenDesktop,
          autoHeight: option.autoHeightDesktop,
        }
      }
    };

    if (swiperOptions.navigation) {
      this.swiperOptions.navigation = {
        ...swiperOptions.navigation
      };
    }

    if (swiperOptions.effect == "fade") {
      this.swiperOptions.effect = "fade";
      this.swiperOptions.fadeEffect = {
        crossFade: true
      };
    }

    if (swiperOptions.pagination == "custom_bullet") {
      this.swiperOptions.pagination = {
        el: swiperOptions.paginationElement,
        clickable: true,
        renderBullet: function (i, className) {
          return `
            <button class="${className}">
              <span></span>
            </button>
          `;
        }
      };
    } else {
      this.swiperOptions.pagination = {
        el: `.swiper-pagination--${swiperOptions.swiperId}`,
        clickable: true
      };
    }

    if (swiperOptions.autoplay) {
      this.swiperOptions.autoplay = {
        ...swiperOptions.autoplay
      };

      if (swiperOptions.autoplayProgress) {
        const progressCircle = this.querySelector(
          `.autoplay-progress--${swiperOptions.swiperId} svg`
        );
        const progressContent = this.querySelector(
          `.autoplay-progress--${swiperOptions.swiperId} span`
        );

        this.swiperOptions.on = {
          autoplayTimeLeft(s, time, progress) {
            progressCircle.style.setProperty("--progress", 1 - progress);
            progressContent.textContent = `${Math.ceil(time / 1000)}`;
          },
        };
      }
    }
    if (swiperOptions.thumbs && swiperOptions.thumbs.swiper) {
    const thumbsSelector = swiperOptions.thumbs.swiper;
    const thumbsEl = document.querySelector(thumbsSelector);

    if (thumbsEl) {
      this.thumbsSwiper = new Swiper(thumbsSelector, {
        slidesPerView: swiperOptions.thumbs.slidesPerView || 4,
        spaceBetween: swiperOptions.thumbs.spaceBetween || 10,
        watchSlidesProgress: true,
        slideToClickedSlide: true
      });

      this.swiperOptions.thumbs = {
        swiper: this.thumbsSwiper
      };
    }
  }
    this.swiper = new Swiper(this, {
      ...this.swiperOptions
      // on: {
      //   init: () => {
      //     setTimeout(() => {
      //       if (this.section) {
      //         this.section.classList.remove(this.hiddenClass);
      //       }
      //     }, 100);
      //   }
      // }
    });
  }
}
customElements.define("swiper-component", SwiperComponent);

class CartUpsell extends MenuDrawer {
  constructor() {
    super();
    this.atcButtons = this.querySelectorAll('[data-add-to-cart]');
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
    this.goBackButton = this.querySelector('button[name="go-back"]');
    this.closeButton = this.querySelector('button[name="close"]');
  }

  connectedCallback() {
    this.atcButtons.forEach(button => {
      button.addEventListener('click', this.addToCartButtonClick.bind(this));
    });
    
    this.goBackButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    });

    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    });
  }

  async addToCartButtonClick(event) {
    event.preventDefault();
    const productId = event.target.dataset.productId || event.target.closest('[data-add-to-cart]').dataset.productId;
    const buttonText = event.target.querySelector(".button__text");
    const loadingSpinner = event.target.querySelector(".loading__spinner");
    
    if(buttonText && loadingSpinner){
      buttonText.style.visibility = "hidden";
      loadingSpinner.style.display = "flex";
    }
    try {
      await addProductToCart(productId, false);
    } catch (error) {
        console.error(error);
      } finally {
        if(buttonText && loadingSpinner){
          buttonText.style.visibility = "";
          loadingSpinner.style.display = "";
        }
      }
  }

  open() {
    if (sessionStorage.getItem('cartUpsellDismissed') === 'true') return;
    this.timer = this.querySelector('message-countdown-timer');
    if(this.timer){
      this.timer.stopCountdown();
      this.timer.remaining = this.timer.duration - 1;
      this.timer.startCountdown();
    }
    super.toggleDrawer();
    setTimeout(() => {
      document.addEventListener("click", this.boundHandleOutsideClick);
    }, 100);
  }

  close(e = undefined, dismissed = true) {
    sessionStorage.setItem('cartUpsellDismissed', dismissed ? 'true' : 'false');
    super.toggleDrawer(e);
    if(document.querySelector('cart-drawer.is-visible')) {
      body.style.overflow = "hidden";
    } 
    document.removeEventListener("click", this.boundHandleOutsideClick);
  }

  handleOutsideClick = (event) => {
    const drawerInner = this.querySelector(".drawer__content");
    if (this.details.hasAttribute("open") && !drawerInner.contains(event.target)){
      this.close(event, false);
    }
  }
}
customElements.define("cart-upsell", CartUpsell);

class checkoutButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('cart-drawer button[name="checkout"]');
    this.upsell = document.querySelector('cart-upsell');
    this.openCartUpsell = this.getAttribute('data-open-cart-upsell');

    if (this.button && this.upsell) {
      this.button.addEventListener("click", (e) => {
        if (sessionStorage.getItem('cartUpsellDismissed') === 'true' || this.openCartUpsell === 'false') {
          window.location.href = '/checkout';
          return;
        };
        e.preventDefault();
        e.stopPropagation();
        this.upsell?.open();
      });
    }

  }
}
customElements.define("checkout-button", checkoutButton);

class MessageCountdownTimer extends HTMLElement {
  constructor() {
    super();
    let raw = this.dataset.duration || "900";
    let duration;

    // Parse MM:SS or seconds
    if (typeof raw === "string" && raw.includes(":")) {
      let parts = raw.split(":");
      duration = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    } else {
      duration = parseInt(raw, 10);
    }

    this.duration = duration;
    this.remaining = this.duration;
    this.timer = null;
  }

  connectedCallback() {
    this.startCountdown();
  }

  startCountdown() {
    this.timer = setInterval(() => {
      let minutes = Math.floor(this.remaining / 60);
      let seconds = this.remaining % 60;

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      this.textContent = `${minutes}:${seconds}`;

      if (--this.remaining < 0) {
        this.remaining = this.duration; // reset when finished
      }
    }, 1000);
  }

  stopCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }
}

customElements.define("message-countdown-timer", MessageCountdownTimer);

class MagnifiedImagesModal {
  static instance = null;

  static open(trigger) {
    if (!MagnifiedImagesModal.instance) {
      MagnifiedImagesModal.instance = new MagnifiedImagesModal();
    }
    MagnifiedImagesModal.instance.open(trigger);
  }

  constructor() {
    this.overlay = document.createElement('div');
    this.overlay.className = 'magnified-images-modal';
    this.overlay.innerHTML = `
      <div class="magnified-images-modal__dialog" role="dialog" tabindex="-1" aria-modal="true">
        <button class="magnified-images-modal__close" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round" aria-hidden="true" focusable="false">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <div class="magnified-images-modal__images"></div>
        <div class="magnified-images-modal__content">
          <h3 class="magnified-images-modal__title"></h3>
          <button class="button button--filled magnified-images-modal__add-to-set">Add to Set</button>
          <button class="button button--text button--filled magnified-images-modal__go-back">Go Back to all <span class="magnified-images-modal__go-back-element">colours</span></button>
        </div>
      </div>
    `;
    document.body.appendChild(this.overlay);

    this.ctaButton = this.overlay.querySelector('.magnified-images-modal__add-to-set');
    this.dialog = this.overlay.querySelector('.magnified-images-modal__dialog');
    this.imagesContainer = this.overlay.querySelector('.magnified-images-modal__images');
    this.titleElement = this.overlay.querySelector('.magnified-images-modal__title');

    this.overlay.querySelector('.magnified-images-modal__close').addEventListener('click', () => this.hide());
    this.overlay.addEventListener('click', () => this.hide());
    this.dialog.addEventListener('click', (e) => e.stopPropagation());
    this.overlay.addEventListener('keyup', (e) => {
      if (e.code?.toUpperCase() === 'ESCAPE') {
        e.preventDefault();
        e.stopPropagation();
        this.hide();
      }
    });

    this.overlay.querySelector('.magnified-images-modal__add-to-set').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const colourElement = this.openedBy?.closest('.drawer__colours.drawer__colours-available-colours');
      this.hide();
      if (colourElement) colourElement.click();
    });

    this.overlay.querySelector('.magnified-images-modal__go-back').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.hide();
    });
  }

  open(trigger) {
    const template = trigger.parentElement?.querySelector('.magnified-images__product-template');
    if (!template) return;

    this.titleElement.textContent = trigger.dataset.productTitle || '';
    this.ctaButton.textContent = trigger?.dataset?.ctaText || 'Add to Set';

    const oldSwiper = this.imagesContainer.querySelector('swiper-component');
    if (oldSwiper?.swiper) oldSwiper.swiper.destroy(true, true);

    this.imagesContainer.innerHTML = '';
    this.imagesContainer.appendChild(template.content.cloneNode(true));

    this.openedBy = trigger;
    bodyScroll.lock(this.dialog);
    this.overlay.setAttribute('open', '');
    trapFocus(this.overlay, this.dialog);

    if(this.openedBy.dataset.element && this.openedBy.dataset.element.trim() !== '') {
      this.elementToChoose = this.openedBy.dataset.element;
      this.overlay.querySelector('.magnified-images-modal__go-back-element').textContent = this.elementToChoose;
    }

    requestAnimationFrame(() => {
      const swiperEl = this.imagesContainer.querySelector('swiper-component');
      if (swiperEl && !swiperEl.swiperInitialized) swiperEl.init();
      this.overlay.querySelectorAll('video').forEach(v => {
        v.load();
        v.addEventListener('loadeddata', () => v.play().catch(() => {}), { once: true });
      });
    });
  }

  hide() {
    this.overlay.querySelectorAll('video').forEach(v => v.pause());
    const swiperEl = this.imagesContainer.querySelector('swiper-component');
    if (swiperEl?.swiper) swiperEl.swiper.destroy(true, true);
    bodyScroll.unlock(this.dialog);
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.overlay.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    this.imagesContainer.innerHTML = '';
  }
}

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.magnified-images__trigger');
  if (trigger){ 
    e.preventDefault();
    e.stopPropagation();
    MagnifiedImagesModal.open(trigger);
  }
}, true);

class CartClear extends HTMLElement {
  constructor() {
    super();
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.onConfirmClear = this.onConfirmClear.bind(this);
    this.onDismissModal = this.onDismissModal.bind(this);
  }

  connectedCallback() {
    this.modal = document.getElementById("CartDrawerClearCartModal");
    if (!this.modal) return;
    this.confirmButton = this.modal.querySelector("[data-cart-clear-confirm]");
    if (this.confirmButton) {
      this.confirmButton.addEventListener("click", this.onConfirmClear);
    }
    this.modal.querySelectorAll("[data-cart-clear-dismiss]").forEach((btn) => {
      btn.addEventListener("click", this.onDismissModal);
    });
  }

  disconnectedCallback() {
    if (this.confirmButton) {
      this.confirmButton.removeEventListener("click", this.onConfirmClear);
    }
    this.modal?.querySelectorAll("[data-cart-clear-dismiss]").forEach((btn) => {
      btn.removeEventListener("click", this.onDismissModal);
    });
  }

  onDismissModal() {
    this.modal?.hide?.();
  }

  onConfirmClear() {
    this.modal?.hide?.();
    this.clearCart();
  }

  clearCart() {
    const sections = this.cart
      .getSectionsToRender()
      .map((section) => section.section);
    const sectionUrl = window.location.pathname;

    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sections: sections,
        sections_url: sectionUrl,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-drawer",
          cartData: data,
        });
        updateFreeShipping();
      });
  }
}

customElements.define("cart-clear", CartClear);